webpackJsonp([1],{

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectStore_vue__ = __webpack_require__(113);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2d872ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectStore_vue__ = __webpack_require__(345);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(341)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectStore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2d872ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectStore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/selectStore.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e2d872ca", Component.options)
  } else {
    hotAPI.reload("data-v-e2d872ca", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'selectStore',
  data: function data() {
    return {
      selectBranch: '',
      selectPOS: '',
      currentBranchPOS: ''
    };
  },

  props: ['cancelBtn'],
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({
    fetchBranch: 'fetchBranch',
    initState: 'initState',
    clearAllData: 'clearAllData',
    setSellsukiAuth: 'setSellsukiAuth',
    setIsloading: 'setIsloading',
    init: 'init'
  }), {
    confirmSelect: function confirmSelect() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var results;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.selectBranch === '' || _this.selectPOS === '')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                results = {
                  branch_id: _this.selectBranch.id,
                  store_id: _this.selectBranch.store_id,
                  unit_id: _this.selectBranch.unitID[_this.selectPOS],
                  warehouse: _this.selectBranch.posWarehouse[_this.selectPOS],
                  tax_id: _this.selectBranch.tax_id,
                  name: _this.selectBranch.name,
                  warehouse_display_name: _this.selectBranch.posWarehouseDisplayName[_this.selectPOS],
                  pos_id: _this.selectBranch.posID[_this.selectPOS]
                };

                _this.setIsloading(true);
                window.localStorage.setItem('currentBranchPOS', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(results));
                _this.initState();
                _this.clearAllData();
                _context.next = 9;
                return _this.init();

              case 9:
                _this.setIsloading(false);
                window.location.reload();

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cancel: function cancel() {
      this.$parent.close();
    },
    logout: function logout() {
      var _this2 = this;

      this.$dialog.confirm({
        title: 'ยืนยันการออกจากระบบ',
        message: '<center>คุณต้องการออกจากระบบใช่หรือไม่ ?</center>',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: function onConfirm() {
          _this2.setSellsukiAuth('');
          window.localStorage.removeItem('currentBranchPOS');
          window.location.href = "http://staging-oms-login.akitahub.com/#/logout?target=a-pos";
        }
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    branchs: 'getBranch',
    mainColor: 'mainColor'
  })),
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var currentBranchID, index;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this3.setIsloading(true);
              _context2.next = 3;
              return _this3.fetchBranch();

            case 3:
              if (_this3.branchs.length === 0) {
                _this3.$toast.open({
                  type: 'is-warning',
                  message: '\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E32\u0E02\u0E32',
                  position: 'is-top-right',
                  duration: '5000',
                  queue: false
                });
              }
              if (_this3.cancelBtn) {
                currentBranchID = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["a" /* getBranchID */])();
                index = _this3.branchs.findIndex(function (obj) {
                  return obj.id === currentBranchID;
                });

                _this3.selectBranch = _this3.branchs[index];
              }
              _this3.setIsloading(false);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },

  watch: {
    selectBranch: function selectBranch() {
      if (this.selectBranch.posID.length === 0) {
        this.$toast.open({
          type: 'is-warning',
          message: '\u0E2A\u0E32\u0E02\u0E32\u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E21\u0E35\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07 POS \u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E32\u0E02\u0E32',
          position: 'is-top-right',
          duration: '5000',
          queue: false
        });
      }
      this.selectPOS = '';
    }
  }
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_request__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__ = __webpack_require__(6);










var OrderProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(OrderProvider, _HttpRequest);

  function OrderProvider() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, OrderProvider);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OrderProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(OrderProvider)).call(this, "https://staging-oms-api.akitahub.com"));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(OrderProvider, [{
    key: 'posCompleteCart',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(params) {
        var _ref2, results;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["f" /* getStoreBearer */])();

              case 3:
                _context.t1 = _context.sent;
                _context.t2 = {
                  'Authorization': _context.t1
                };

                _context.t0.setHeader.call(_context.t0, _context.t2);

                _context.next = 8;
                return this.create('/bill/poscompletecart', params.data);

              case 8:
                _ref2 = _context.sent;
                results = _ref2.data.results;
                return _context.abrupt('return', results);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function posCompleteCart(_x) {
        return _ref.apply(this, arguments);
      }

      return posCompleteCart;
    }()
  }, {
    key: 'init',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref4, data, billExpire, paymentChannel;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = this;
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["f" /* getStoreBearer */])();

              case 3:
                _context2.t1 = _context2.sent;
                _context2.t2 = {
                  'Authorization': _context2.t1
                };

                _context2.t0.setHeader.call(_context2.t0, _context2.t2);

                _context2.next = 8;
                return this.get('/init');

              case 8:
                _ref4 = _context2.sent;
                data = _ref4.data;
                billExpire = data.results.store.default_bill_expire_day;
                paymentChannel = data.results.store_payment_channel.map(function (payment) {
                  return {
                    id: payment.spc.id,
                    payment_name: payment.pc.name,
                    payment_channel_id: payment.spc.payment_channel_id,
                    logo: payment.pc.logo
                  };
                });
                return _context2.abrupt('return', {
                  billExpire: billExpire,
                  paymentChannel: paymentChannel,
                  initData: data.results
                });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _ref3.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return OrderProvider;
}(__WEBPACK_IMPORTED_MODULE_7__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (OrderProvider);

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_request__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js__);











var PrintProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PrintProvider, _HttpRequest);

  function PrintProvider() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PrintProvider);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PrintProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PrintProvider)).call(this, '' + "https://staging-gw-print-proxy-api.akitahub.com"));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PrintProvider, [{
    key: 'getPrinters',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(branchId) {
        var newStore, _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newStore = __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] ? __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] : '000000000';
                _context.next = 3;
                return this.get('/public/' + newStore.id + '/printers/' + branchId);

              case 3:
                _ref2 = _context.sent;
                data = _ref2.data;
                return _context.abrupt('return', data);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPrinters(_x) {
        return _ref.apply(this, arguments);
      }

      return getPrinters;
    }()
  }, {
    key: 'printReceipt',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(payload) {
        var newStore, _ref4, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                newStore = __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] ? __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] : '000000000';
                _context2.next = 3;
                return this.create('/public/' + newStore.id + '/prints/receipt', payload);

              case 3:
                _ref4 = _context2.sent;
                data = _ref4.data;
                return _context2.abrupt('return', data);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function printReceipt(_x2) {
        return _ref3.apply(this, arguments);
      }

      return printReceipt;
    }()
  }, {
    key: 'printReportZ',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(payload) {
        var newStore, _ref6, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newStore = __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] ? __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] : '000000000';
                _context3.next = 3;
                return this.create('/public/' + newStore.id + '/prints/report-z', payload);

              case 3:
                _ref6 = _context3.sent;
                data = _ref6.data;
                return _context3.abrupt('return', data);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function printReportZ(_x3) {
        return _ref5.apply(this, arguments);
      }

      return printReportZ;
    }()
  }]);

  return PrintProvider;
}(__WEBPACK_IMPORTED_MODULE_7__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PrintProvider);

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListProduct__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helper_localStorage__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    ListProduct: __WEBPACK_IMPORTED_MODULE_3__ListProduct__["a" /* default */]
  },
  data: function data() {
    return {
      page: 1,
      search: '',
      activeModal: false,
      branchName: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['setSearchKey', 'loadProductMore', 'setIsloading']), {
    getBranch: function getBranch() {
      var getItem = window.localStorage.getItem('currentBranchPOS');
      var result = JSON.parse(getItem);
      return result;
    },
    searchData: function searchData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var hasProduct;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setIsloading(true);
                _context.next = 3;
                return _this.setSearchKey(_this.search);

              case 3:
                hasProduct = _context.sent;

                _this.setIsloading(false);
                if (!hasProduct) {
                  _this.$dialog.alert({
                    title: 'เกิดข้อผิดพลาด',
                    confirmText: 'ตกลง',
                    message: '<center>ข้อมูลไม่ตรงกับสินค้าในระบบ</center>'
                  });
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    scrollHanle: function scrollHanle(evt) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var scrollBottom, height;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                scrollBottom = evt.target.scrollTop + evt.target.clientHeight;
                height = evt.target.scrollHeight;

                if (!(evt.target.scrollTop !== 0 && scrollBottom === height)) {
                  _context2.next = 8;
                  break;
                }

                if (!(_this2.productsNumber % 25 === 0)) {
                  _context2.next = 8;
                  break;
                }

                _this2.setIsloading(true);
                _context2.next = 7;
                return _this2.loadProductMore(++_this2.page);

              case 7:
                _this2.setIsloading(false);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    amount: 'getItemsAmount',
    searchKey: 'getSearchKey',
    products: 'getProduct',
    productsNumber: 'productsNumber',
    storeName: 'storeName',
    mainColor: 'mainColor'
  })),
  created: function created() {
    this.search = this.searchKey;
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this3.branchName = Object(__WEBPACK_IMPORTED_MODULE_5__utils_helper_localStorage__["b" /* getBranchName */])();

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list-product',
  props: ['products', 'searchKey'],
  data: function data() {
    return {
      amountItem: 1
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['addItem']), {
    addItemData: function addItemData(item) {
      for (var i = 0; i < this.amountItem; i++) {
        this.addItem(item);
      }
    }
  }),
  watch: {
    amountItem: function amountItem(val) {
      if (val <= 0) {
        this.amountItem = 1;
      }
    }
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scan-search',
  data: function data() {
    return {
      paused: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    mainColor: 'mainColor'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    onDecode: function onDecode(content) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var contents, idOfProdect, hasProduct;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!content) {
                  _context.next = 9;
                  break;
                }

                contents = content.split('/');
                idOfProdect = contents[contents.length - 1];
                _context.next = 5;
                return _this.setSearchKey(idOfProdect);

              case 5:
                hasProduct = _context.sent;

                _this.playSound();
                _this.$router.push({ name: 'Home' });
                if (!hasProduct) {
                  _this.$dialog.alert({
                    title: 'เกิดข้อผิดพลาด',
                    confirmText: 'ตกลง',
                    message: '<center>ข้อมูลไม่ตรงกับสินค้าในระบบ</center>'
                  });
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    playSound: function playSound() {
      var audio = new Audio(__webpack_require__(407));
      audio.play();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setSearchKey']))
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ListCart__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_tel_input__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_tel_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_tel_input__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cart',
  data: function data() {
    return {
      tel: '',
      promoCode: '',
      phone: {},
      isTel: false,
      isCode: false,
      isReady: false
    };
  },

  components: {
    ListCart: __WEBPACK_IMPORTED_MODULE_4__ListCart__["a" /* default */],
    VueTelInput: __WEBPACK_IMPORTED_MODULE_5_vue_tel_input___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['clearAllData', 'verifyPromoCode', 'clearDiscount', 'setTel', 'setIsloading', 'fetchPrinters']), {
    onInputTel: function onInputTel(_ref) {
      var number = _ref.number,
          isValid = _ref.isValid,
          country = _ref.country;

      this.phone = {
        number: number.replace(/ /g, ''),
        isValid: isValid,
        country: country
      };
    },
    clearPromotionCode: function clearPromotionCode() {
      this.promoCode = '';
      this.isCode = false;
    },
    clear: function clear() {
      var _this = this;

      this.$dialog.confirm({
        title: 'ลบสินค้าทุกชิ้นออกจากตระกร้า',
        message: 'คุณแน่ใจแล้วใช่ไหมที่จะ<span class="error-message">ลบสินค้าทุกชิ้น</span>ออกจากตระกร้า?',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: function onConfirm() {
          _this.clearAllData();
          _this.$router.push({ name: 'Home' });
        }
      });
    },
    verifyCode: function verifyCode() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var message, params, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.setIsloading(true);
                message = '';
                params = {
                  promoCode: _this2.promoCode.toUpperCase(),
                  tel: _this2.getTel,
                  getFullPrice: _this2.getFullPrice
                };
                _context.next = 5;
                return _this2.verifyPromoCode(params);

              case 5:
                res = _context.sent;

                if (res.data.success) {
                  message = '<center>Code <span class="success-message">' + res.data.promotion_code.code + '</span> can be use.</center>';
                  _this2.isCode = true;
                } else {
                  message = '<center><span class="error-message">' + res.data.error.message + '</center>';
                }
                _this2.setIsloading(false);
                _this2.$dialog.alert({
                  confirmText: 'ตกลง',
                  title: res.title,
                  message: message
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    setMemberTel: function setMemberTel() {
      var tel = this.tel.replace(/ /g, '');
      if (this.phone.isValid) {
        this.setTel(tel);
        this.isTel = true;
      } else {
        this.$dialog.alert({
          confirmText: 'ตกลง',
          title: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
          message: 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง'
        });
      }
    },
    confirm: function confirm() {
      this.$router.push({ name: 'Payment' });
    },
    changTel: function changTel() {
      this.isTel = false;
      this.phone = {};
      this.isCode = false;
      this.tel = '';
      this.promoCode = '';
      this.clearDiscount();
      this.setTel();
    },
    changCode: function changCode() {
      this.isCode = false;
      this.clearDiscount();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    netPrice: 'getNetPrice',
    discount: 'discount',
    amount: 'getItemsAmount',
    items: 'getItems',
    getTel: 'getTel',
    promotionCode: 'getPromotionCode',
    getFullPrice: 'getFullPrice',
    mainColor: 'mainColor'
  })),
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log(_this3);
              _context2.next = 3;
              return _this3.fetchPrinters();

            case 3:
              if (_this3.getTel !== '') {
                _this3.tel = _this3.getTel;
                _this3.isTel = true;
              }
              if (_this3.promotionCode.code && _this3.promotionCode.code !== '') {
                _this3.promoCode = _this3.promotionCode.code;
                _this3.isCode = true;
              } else {
                _this3.isCode = false;
                _this3.clearDiscount();
              }

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },

  watch: {
    amount: function amount(val) {
      if (val === 0) {
        this.$router.push({ name: 'Home' });
      }
    }
  }
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  name: 'list-cart',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['addQuantity', 'removeItem']), {
    confirmCustomDelete: function confirmCustomDelete(item) {
      var _this = this;

      console.log(item);
      this.$dialog.confirm({
        title: 'ลบสินค้าออกจากตระกร้า',
        message: 'คุณแน่ใจแล้วใช่ไหมที่จะ<span class="error-message">ลบสินค้าชิ้นนี้</span>ออกจากตระกร้า?',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: function onConfirm() {
          _this.removeItem(item);
          _this.$emit('clearPromotionCode');
        }
      });
    }
  })
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'payment',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    netPrice: 'getNetPrice',
    mainColor: 'mainColor'
  }))
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SelectPrinter__ = __webpack_require__(283);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkout-by-cash',
  components: {
    SelectPrinter: __WEBPACK_IMPORTED_MODULE_4__components_SelectPrinter__["a" /* default */]
  },
  data: function data() {
    return {
      receive: 0,
      activeModal: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setChange', 'setReceivedCash', 'calculatedChange', 'checkout', 'setIsloading', 'setPrintReceipt', 'fetchPrinters']), {
    finishCheckout: function finishCheckout(paymentType) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.change < 0)) {
                  _context.next = 4;
                  break;
                }

                _this.$dialog.alert({
                  title: 'เกิดข้อผิดพลาด',
                  confirmText: 'ตกลง',
                  message: 'เงินที่ได้รับน้อยกว่ามูลค้าสินค้า <br> กรุณาใส่จำนวนเงินที่ได้รับใหม่อีกครั้ง'
                });
                _context.next = 9;
                break;

              case 4:
                _this.setIsloading(true);
                _context.next = 7;
                return _this.checkout(paymentType);

              case 7:
                _this.setIsloading(false);
                _this.activeModal = true;

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clear: function clear() {
      this.setChange(0);
      this.setReceivedCash(0);
      this.receive = 0;
    },
    addReceive: function addReceive(money) {
      this.receive = this.receive === '' ? money : parseInt(this.receive) + money;
      this.calculatedChange({ receive: this.receive, netPrice: this.netPrice });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    netPrice: 'getNetPrice',
    fullPrice: 'getFullPrice',
    change: 'getChange',
    receivedCash: 'getReceivedCash',
    mainColor: 'mainColor'
  })),
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.fetchPrinters();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectPrinter_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4516a6f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectPrinter_vue__ = __webpack_require__(470);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(468)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4516a6f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectPrinter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4516a6f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectPrinter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/check-out/components/SelectPrinter.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4516a6f6", Component.options)
  } else {
    hotAPI.reload("data-v-4516a6f6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'receipt',
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['clearAllData', 'setIsloading', 'printReceiptAction']), {
    finishPrint: function finishPrint(printerIP) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  printerIP: printerIP,
                  status: 'pending'
                };

                _this.setIsloading(true);
                _context.next = 4;
                return _this.printReceiptAction(params);

              case 4:
                _this.clearData();
                _this.setIsloading(false);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clearData: function clearData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.clearAllData();
                _this2.$router.push({ name: 'Home' });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    printers: 'getPrinters',
    billID: 'getBillID',
    mainColor: 'mainColor'
  }))
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SelectPrinter__ = __webpack_require__(283);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkout-by-cash',
  components: {
    SelectPrinter: __WEBPACK_IMPORTED_MODULE_4__components_SelectPrinter__["a" /* default */]
  },
  data: function data() {
    return {
      activeModal: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['checkout', 'setIsloading', 'fetchPrinters']), {
    finishCheckout: function finishCheckout(paymentType) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setIsloading(true);
                _context.next = 3;
                return _this.checkout(paymentType);

              case 3:
                _this.setIsloading(false);
                _this.activeModal = true;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    netPrice: 'getNetPrice',
    fullPrice: 'getFullPrice',
    mainColor: 'mainColor'
  })),
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.fetchPrinters();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_selectStore__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helper_localStorage__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-info',
  data: function data() {
    return {
      sellsukiVersion: window.sellsukiVersion,
      activeModal: false,
      userInfo: {
        user: {
          id: '',
          first_name: '',
          last_name: '',
          username: '',
          branch_name: '',
          pos_id: ''
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    mainColor: 'mainColor'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    back: function back() {
      this.$router.push({ path: '/' });
    },
    logout: function logout() {
      var _this = this;

      this.$dialog.confirm({
        title: 'ยืนยันการออกจากระบบ',
        message: '<center>คุณต้องการออกจากระบบใช่หรือไม่ ?</center>',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: function onConfirm() {
          _this.setSellsukiAuth('');
          window.localStorage.removeItem('currentBranchPOS');
          window.location.href = "http://staging-oms-login.akitahub.com/#/logout?target=a-pos";
        }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['setSellsukiAuth']), {
    changeBranch: function changeBranch() {
      this.activeModal = true;
    },
    getBranchNameDisplay: function getBranchNameDisplay() {
      this.userInfo.user.branch_name = Object(__WEBPACK_IMPORTED_MODULE_5__utils_helper_localStorage__["b" /* getBranchName */])();
      this.userInfo.user.pos_id = Object(__WEBPACK_IMPORTED_MODULE_5__utils_helper_localStorage__["d" /* getPOSID */])();
    }
  }),
  components: {
    selectStore: __WEBPACK_IMPORTED_MODULE_3__views_selectStore__["a" /* default */]
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_5__utils_helper_localStorage__["e" /* getSellsukiUser */])();

            case 2:
              _this2.userInfo = _context.sent;

              _this2.getBranchNameDisplay();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resources_report_provider__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resources_print_provider__ = __webpack_require__(255);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var reportProvider = new __WEBPACK_IMPORTED_MODULE_6__resources_report_provider__["a" /* default */]();

var printService = new __WEBPACK_IMPORTED_MODULE_7__resources_print_provider__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReportZ',
  data: function data() {
    return {
      maxDate: new Date(),
      selectedDate: new Date(),
      selectedPrinter: '',
      startPrice: '',
      givePrice: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    printers: 'getPrinters',
    storeId: 'storeId',
    mainColor: 'mainColor'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['fetchPrinters', 'setReceiptData', 'setIsloading', 'triggerPrinter']), {
    back: function back() {
      this.$router.push({ path: '/user-info' });
    },
    print: function print() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formatSelectedDate, reportZ, currentBranchPOS, payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setIsloading(true);

                if (!_this.validateData()) {
                  _context.next = 5;
                  break;
                }

                _this.setIsloading(false);
                _this.$dialog.alert({
                  title: 'เกิดข้อผิดพลาด',
                  confirmText: 'ตกลง',
                  message: 'มีบางอย่างผิดพลาดกรุณากรอกข้อมูลให้ครบ'
                });
                return _context.abrupt('return');

              case 5:
                formatSelectedDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this.selectedDate).subtract(1, 'days').format('YYYY-MM-D');
                _context.next = 8;
                return reportProvider.getReportZ(formatSelectedDate);

              case 8:
                reportZ = _context.sent;
                currentBranchPOS = Object(__WEBPACK_IMPORTED_MODULE_3__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])();
                payload = {
                  sumBillNet: parseFloat(reportZ.sum_bill_net),
                  sumBillDiscount: parseFloat(reportZ.sum_bill_discount),
                  startPrice: parseFloat(_this.startPrice),
                  givePrice: parseFloat(_this.givePrice),
                  countBill: parseInt(reportZ.count_bill),
                  firstBill: reportZ.first_bill[0] ? reportZ.first_bill[0] : null,
                  lastBill: reportZ.last_bill[0] ? reportZ.last_bill[0] : null,
                  displayTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('DD-MM-YYYY HH:mm'),
                  printTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('DD-MM-YYYY HH:mm'),
                  storeDisplayName: 'Gentlewoman',
                  payments: reportZ.payment.map(function (re) {
                    return {
                      total: parseFloat(re.total),
                      type: re.payment_channel === 'Cash' || re.payment_channel === 'cash' ? 'cash' : 'credit'
                    };
                  }),
                  print: {
                    message: '',
                    status: 'pending',
                    ip: _this.selectedPrinter
                  },
                  branchPos: {
                    branchId: parseInt(currentBranchPOS.branch_id),
                    name: currentBranchPOS.name,
                    posId: currentBranchPOS.pos_id,
                    taxId: 'TAX#0-1055-61034-56-1',
                    unitId: parseInt(currentBranchPOS.unit_id),
                    code: currentBranchPOS.warehouse
                  }
                };
                _context.prev = 11;
                _context.next = 14;
                return printService.printReportZ(payload);

              case 14:
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](11);

                console.log(_context.t0);
                alert('ไม่พบรายงานการขาย');

              case 20:
                _this.setIsloading(false);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[11, 16]]);
      }))();
    },
    validateData: function validateData() {
      return this.selectedPrinter === '' || this.startPrice === '' || this.givePrice === '';
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.fetchPrinters();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      PdogLoad: true
    };
  },

  name: 'PrepareLogin',
  props: ['storeId'],
  created: function created() {
    if (this.storeId) {
      this.$sellsuki_auth.initLocalStorage(this.storeId);
    } else {
      this.$sellsuki_auth.initLocalStorage(0);
    }
  }
});

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var HttpRequest = function () {
  function HttpRequest(url) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HttpRequest);

    this.axiosInstance = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
      baseURL: url,
      timeout: 120000
    });
    this.axiosInstance.interceptors.request.use(function (config) {
      // Do something before request is sent
      return config;
    }, function (error) {
      // Do something with request error
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
    // Add a response interceptor
    // this.axiosInstance.interceptors.response.use(function (response) {
    //   // Do something with response data
    //   return response
    // }, function (error) {
    //   // Do something with response error
    //   if (error.response.status === 401) {
    //     window.location.href = process.env.SELLSUKI_LOGOUT_PORTAL
    //   }
    //   return Promise.reject(error)
    // })
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(HttpRequest, [{
    key: 'setHeader',
    value: function setHeader(header) {
      this.axiosInstance.defaults.headers.common = header;
      this.axiosInstance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    }
  }, {
    key: 'get',
    value: function get(methodName, data) {
      return this.axiosInstance.get(methodName, {
        params: data
      });
    }
  }, {
    key: 'create',
    value: function create(methodName, data, param) {
      return this.axiosInstance.post(methodName, data, {
        params: param
      });
    }
  }, {
    key: 'update',
    value: function update(methodName, data) {
      return this.axiosInstance.put(methodName, data);
    }
  }, {
    key: 'delete',
    value: function _delete(methodName, param, data) {
      return this.axiosInstance.delete(methodName, {
        params: param,
        data: data
      });
    }
  }, {
    key: 'request',
    value: function request(type, url, data) {
      var promise = null;
      switch (type) {
        case 'GET':
          promise = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: data });break;
        case 'POST':
          promise = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, data);break;
        case 'PUT':
          promise = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, data);break;
        case 'DELETE':
          promise = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url, data);break;
        default:
          promise = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: data });break;
      }
      return promise;
    }
  }]);

  return HttpRequest;
}();

/* harmony default export */ __webpack_exports__["a"] = (HttpRequest);

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sellsuki_version_js__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sellsuki_version_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sellsuki_version_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_filter__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_buefy__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_main_css__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_buefy_lib_buefy_css__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_buefy_lib_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_buefy_lib_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_begeta_css_begeta_min_css__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_begeta_css_begeta_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_begeta_css_begeta_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_perfect_scrollbar__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_oms_auth__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_oms_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_oms_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_svg_filler__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_svg_filler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_svg_filler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_tel_input_dist_vue_tel_input_css__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_tel_input_dist_vue_tel_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_tel_input_dist_vue_tel_input_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














// import VueTelInput from 'vue-tel-input'

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_buefy___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('svg-filler', __WEBPACK_IMPORTED_MODULE_12_vue_svg_filler___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('VuePerfectScrollbar', __WEBPACK_IMPORTED_MODULE_10_vue_perfect_scrollbar___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_oms_auth___default.a, {
  portal: "http://staging-oms-login.akitahub.com/#/choosestore?target=a-pos",
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]
});
// Vue.use(VueTelInput)

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

window.sellsukiVersion = 'd8b92e2'


/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(346);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(296);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("79060927", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\np.modal-card-title {\n  text-align: center;\n  font-size: 1.4rem;\n}\nbutton.button.is-primary, button.button.is-primary:hover, button.button.is-primary:focus, button.button.is-primary:active {\n  background: black;\n}\n.modal-card.animation-content footer.modal-card-foot {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.success-message {\n  font-weight: bold;\n  color: #27cf5a;\n}\n.error-message {\n  font-weight: bold;\n  color: #f83c3c;\n}\n* {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\ninput {\n  -webkit-user-select: text;\n     -moz-user-select: text;\n      -ms-user-select: text;\n          user-select: text;\n}\ninput.input {\n  font-size: 0.9rem;\n}\nhtml,\nbody{\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  position: relative;\n}\n#app {\n  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */\n  /* font-family: 'Tahoma', Geneva, sans-serif; */\n  font-family: Tahoma, Arial;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #2c3e50;\n}\nmain {\n  text-align: center;\n}\n\n", ""]);

// exports


/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(342);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("33cdce45", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e2d872ca\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./selectStore.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e2d872ca\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./selectStore.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\n.body-box {\n  border-radius: 4px;\n}\n", ""]);

// exports


/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "bg-cl-white body-box dp-flex jtf-ct-center al-it-center f-drt-column"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-100pct bg-cl-light cl-black f-s-22px f-w-bold pd-18px t-al-center"
        },
        [_vm._v("\n    ตั้งค่าสาขา\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-80pct mg-vtc-10px" },
        [
          _c(
            "b-select",
            {
              attrs: { expanded: "" },
              model: {
                value: _vm.selectBranch,
                callback: function($$v) {
                  _vm.selectBranch = $$v
                },
                expression: "selectBranch"
              }
            },
            [
              _c("option", { attrs: { value: "", disabled: "" } }, [
                _vm._v("เลือกสาขา")
              ]),
              _vm._v(" "),
              _vm._l(_vm.branchs, function(branch, index) {
                return _c(
                  "option",
                  { key: index, domProps: { value: branch } },
                  [_vm._v("\n        " + _vm._s(branch.name) + "\n      ")]
                )
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectBranch !== ""
        ? _c(
            "div",
            { staticClass: "w-80pct mg-vtc-10px" },
            [
              _c(
                "b-select",
                {
                  attrs: { expanded: "" },
                  model: {
                    value: _vm.selectPOS,
                    callback: function($$v) {
                      _vm.selectPOS = $$v
                    },
                    expression: "selectPOS"
                  }
                },
                [
                  _c("option", { attrs: { value: "", disabled: "" } }, [
                    _vm._v("POS ID")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.selectBranch.posID, function(pos, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: index } },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(pos) +
                            "( " +
                            _vm._s(
                              _vm.selectBranch.posWarehouseDisplayName[index]
                            ) +
                            " )\n      "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "w-80pct mg-vtc-10px pd-vtc-10px cl-white cs-pointer bd-rd-4px f-w-bold t-al-center",
          style: "background-color: " + _vm.mainColor + ";"
        },
        [
          _c(
            "div",
            {
              on: {
                click: function($event) {
                  _vm.confirmSelect()
                }
              }
            },
            [_vm._v("\n      ตกลง\n    ")]
          )
        ]
      ),
      _vm._v(" "),
      _vm.cancelBtn
        ? _c(
            "div",
            {
              staticClass:
                "w-80pct mg-vtc-10px pd-vtc-10px bg-cl-light cs-pointer bd-rd-4px f-w-bold"
            },
            [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      _vm.cancel()
                    }
                  }
                },
                [_vm._v("\n      ยกเลิก\n    ")]
              )
            ]
          )
        : _c(
            "div",
            {
              staticClass:
                "w-80pct mg-vtc-10px pd-vtc-10px bg-cl-light cs-pointer bd-rd-4px f-w-bold t-al-center"
            },
            [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      _vm.logout()
                    }
                  }
                },
                [_vm._v("\n      ออกจากระบบ\n    ")]
              )
            ]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2d872ca", esExports)
  }
}

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _vm.isUpToDate
      ? _c(
          "div",
          [
            _c("b-loading", {
              attrs: { "is-full-page": true, active: _vm.isLoading },
              on: {
                "update:active": function($event) {
                  _vm.isLoading = $event
                }
              }
            }),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: { active: _vm.activeModal, canCancel: [] },
                on: {
                  "update:active": function($event) {
                    _vm.activeModal = $event
                  }
                }
              },
              [_c("selectStore", { attrs: { cancelBtn: false } })],
              1
            ),
            _vm._v(" "),
            _c("main", [_c("router-view")], 1)
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persist__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_cart__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_payment__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_print__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_product__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_sellsukiData__ = __webpack_require__(391);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_2_vuex_persist__["a" /* default */]({
  key: 'store',
  storage: localStorage
});

var store = function store() {
  return new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
      cart: __WEBPACK_IMPORTED_MODULE_3__modules_cart__["a" /* default */],
      payment: __WEBPACK_IMPORTED_MODULE_4__modules_payment__["a" /* default */],
      print: __WEBPACK_IMPORTED_MODULE_5__modules_print__["a" /* default */],
      product: __WEBPACK_IMPORTED_MODULE_6__modules_product__["a" /* default */],
      sellsukiData: __WEBPACK_IMPORTED_MODULE_7__modules_sellsukiData__["a" /* default */]
    },
    plugins: [vuexLocalStorage.plugin]
  });
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_promotion_provider__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helper_localStorage__ = __webpack_require__(6);




var promotionProvider = new __WEBPACK_IMPORTED_MODULE_2__resources_promotion_provider__["a" /* default */]();

var state = {
  items: [],
  customerTel: '',
  discount: 0,
  promotionCode: {}
};

var actions = {
  verifyPromoCode: function verifyPromoCode(_ref, payload) {
    var _this = this;

    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        state = _ref.state;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return promotionProvider.verifyPromotionCode({
                code: payload.promoCode,
                memberTel: payload.tel,
                items: state.items,
                warehouse: {
                  id: parseInt(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])().branch_id),
                  name: Object(__WEBPACK_IMPORTED_MODULE_3__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])().warehouse_display_name,
                  code: Object(__WEBPACK_IMPORTED_MODULE_3__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])().warehouse
                }
              });

            case 2:
              res = _context.sent;

              if (res.data.success) {
                commit('SET_PROMOTION_CODE', res.data.promotion_code);
                commit('SET_DISCOUNT', res.data.discount);
              } else {
                dispatch('clearDiscount');
              }
              return _context.abrupt('return', res);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  addItem: function addItem(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!payload) {
                _context2.next = 4;
                break;
              }

              commit('ADD_ITEM', payload);
              commit('CLEAR_DISCOUNT');
              return _context2.abrupt('return', true);

            case 4:
              return _context2.abrupt('return', false);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  removeItem: function removeItem(_ref3, payload) {
    var commit = _ref3.commit;

    commit('REMOVE_ITEM', payload);
    commit('CLEAR_DISCOUNT');
  },
  setTel: function setTel(_ref4, payload) {
    var commit = _ref4.commit;

    commit('SET_TEL', payload);
  },
  clearAllData: function clearAllData(_ref5) {
    var dispatch = _ref5.dispatch,
        commit = _ref5.commit;

    this.dispatch('clearMoney');
    this.dispatch('initState');
    dispatch('clearDiscount');
    commit('CLEAR_ITEM_IN_CART');
    dispatch('setTel');
  },
  clearDiscount: function clearDiscount(_ref6) {
    var commit = _ref6.commit;

    commit('CLEAR_DISCOUNT');
  }
};

var mutations = {
  ADD_ITEM: function ADD_ITEM(state, payload) {
    state.items.push(payload);
  },
  SET_PROMOTION_CODE: function SET_PROMOTION_CODE(state, payload) {
    state.promotionCode = payload;
  },
  SET_DISCOUNT: function SET_DISCOUNT(state, payload) {
    state.discount = payload;
  },
  CLEAR_ITEM_IN_CART: function CLEAR_ITEM_IN_CART(state) {
    state.items = [];
  },
  REMOVE_ITEM: function REMOVE_ITEM(state, payload) {
    var index = state.items.findIndex(function (item) {
      return item.id === payload.id;
    });
    state.items.splice(index, 1);
  },
  CLEAR_DISCOUNT: function CLEAR_DISCOUNT(state) {
    state.discount = 0;
    state.promotionCode = {};
  },
  SET_TEL: function SET_TEL(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    state.customerTel = payload;
  }
};

var getters = {
  getItems: function getItems(state) {
    return state.items;
  },
  getFullPrice: function getFullPrice(state) {
    return state.items.reduce(function (sum, item) {
      return sum + parseInt(item.price);
    }, 0);
  },
  getNetPrice: function getNetPrice(state) {
    var netPrice = state.items.reduce(function (sum, item) {
      return sum + parseInt(item.price);
    }, 0) - state.discount;
    return netPrice <= 0 ? 0 : netPrice;
  },
  getItemsAmount: function getItemsAmount(state) {
    return state.items.reduce(function (sum, item) {
      return sum + item.quantity;
    }, 0);
  },
  getDiscount: function getDiscount(state) {
    return state.discount;
  },
  discount: function discount(state) {
    return state.discount;
  },
  getPromotionCode: function getPromotionCode(state) {
    return state.promotionCode;
  },
  getTel: function getTel(state) {
    return state.customerTel;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_request__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js__);











var PromotionProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PromotionProvider, _HttpRequest);

  function PromotionProvider() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PromotionProvider);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PromotionProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PromotionProvider)).call(this, '' + "https://camp-stg.herokuapp.com"));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PromotionProvider, [{
    key: 'verifyPromotionCode',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
        var validatePromotionCodePayload, newStore, _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                validatePromotionCodePayload = {
                  code: payload.code,
                  member: {
                    tel: payload.memberTel
                  },
                  items: payload.items.map(function (item) {
                    return {
                      sku_id: parseInt(item.id),
                      code: item.code,
                      name: item.name,
                      amount: parseInt(item.amount),
                      option: '',
                      price: parseFloat(item.price),
                      full_price: parseFloat(item.fullPrice),
                      productId: parseInt(item.productId),
                      brand: {
                        id: 2,
                        name: 'a'
                      },
                      warehouse: {
                        id: payload.warehouse.id,
                        name: payload.warehouse.name,
                        code: payload.warehouse.code
                      },
                      categories: item.categories,
                      tags: item.tags
                    };
                  }),
                  channel: 'pos'
                };
                _context.prev = 1;
                newStore = __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] ? __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] : '000000000';
                _context.next = 5;
                return this.create('/public/' + newStore.id + '/promotion-codes/validate', validatePromotionCodePayload);

              case 5:
                _ref2 = _context.sent;
                data = _ref2.data;
                return _context.abrupt('return', data);

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);
                return _context.abrupt('return', {
                  data: { success: false,
                    error: {
                      message: _context.t0.response ? _context.t0.response.data.message : 'Server error or Incorect store.'
                    }
                  }
                });

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 10]]);
      }));

      function verifyPromotionCode(_x) {
        return _ref.apply(this, arguments);
      }

      return verifyPromotionCode;
    }()
  }]);

  return PromotionProvider;
}(__WEBPACK_IMPORTED_MODULE_7__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PromotionProvider);

/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_modules_payment__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_order_provider__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resources_member_order_history__ = __webpack_require__(382);







var orderProvider = new __WEBPACK_IMPORTED_MODULE_5__resources_order_provider__["a" /* default */]();
var memberOrderProvider = new __WEBPACK_IMPORTED_MODULE_6__resources_member_order_history__["a" /* default */]();

var state = {
  type: '',
  change: '',
  receivedMoney: {
    receivedCash: '',
    receivedCard: ''
  },
  memberOrderHistory: {},
  total: '',
  order: {},
  time: ''
};

var actions = {
  setOrder: function setOrder(_ref, payload) {
    var _this = this;

    var commit = _ref.commit,
        getters = _ref.getters,
        state = _ref.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var params, promoCode, cashier, order, _ref2, data;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log(payload);
              commit('SET_TOTAL');
              params = Object(__WEBPACK_IMPORTED_MODULE_3__utils_modules_payment__["a" /* initDataSetOrder */])(payload, state, getters.getTel, getters.billExpire);
              promoCode = getters.getPromotionCode;
              cashier = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["j" /* getUserCashier */])();
              _context.next = 7;
              return orderProvider.posCompleteCart(params, promoCode, getters.getTel);

            case 7:
              order = _context.sent;
              _context.next = 10;
              return memberOrderProvider.createOrderHistory({
                order: order,
                tel: getters.getTel,
                items: getters.getItems,
                promotionCode: getters.getPromotionCode,
                cashier: cashier
              });

            case 10:
              _ref2 = _context.sent;
              data = _ref2.data;

              console.log(data);
              commit('SET_ORDER', order);
              commit('SET_MEMBER_ORDER_HISTORY', data);

              return _context.abrupt('return', data);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  calculatedChange: function calculatedChange(_ref3, payload) {
    var commit = _ref3.commit;

    commit('CALCULATED_CHANGE', payload);
  },
  setChange: function setChange(_ref4, payload) {
    var commit = _ref4.commit;

    commit('SET_CHANGE', payload);
  },
  setReceivedCash: function setReceivedCash(_ref5, payload) {
    var commit = _ref5.commit;

    commit('SET_RECEIVE_CASH', payload);
  },
  clearMoney: function clearMoney(_ref6) {
    var commit = _ref6.commit;

    commit('CLEAR_MONEY');
  },
  checkout: function checkout(_ref7, channel) {
    var _this2 = this;

    var dispatch = _ref7.dispatch,
        getters = _ref7.getters,
        commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var paymentChannels, paymentChannelIndex, payPal;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (channel === 'Credit') {
                commit('SET_RECEIVED_CARD', getters.getNetPrice);
                commit('SET_RECEIVE_CASH', 0);
                commit('SET_CHANGE', 0);
              } else {
                commit('SET_RECEIVED_CARD', 0);
              }
              paymentChannels = getters.paymentChannel;
              paymentChannelIndex = paymentChannels.findIndex(function (type) {
                return type.payment_name === channel;
              });
              payPal = paymentChannels.find(function (type) {
                return type.payment_name === 'Paypal';
              });

              if (!(paymentChannelIndex === -1)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 7;
              return commit('SET_TYPE', payPal);

            case 7:
              _context2.next = 11;
              break;

            case 9:
              _context2.next = 11;
              return commit('SET_TYPE', paymentChannels[paymentChannelIndex]);

            case 11:
              _context2.next = 13;
              return commit('SET_TIME', new Date());

            case 13:
              _context2.next = 15;
              return dispatch('setOrder', { items: getters.getItems, price: getters.getNetPrice });

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};

var mutations = {
  SET_TYPE: function SET_TYPE(state, payload) {
    state.type = payload;
  },
  SET_ORDER: function SET_ORDER(state, payload) {
    state.order = payload;
  },
  CALCULATED_CHANGE: function CALCULATED_CHANGE(state, payload) {
    state.receivedMoney.receivedCash = payload.receive;
    state.change = state.receivedMoney.receivedCash - payload.netPrice;
  },
  SET_MEMBER_ORDER_HISTORY: function SET_MEMBER_ORDER_HISTORY(state, payload) {
    state.memberOrderHistory = payload;
  },
  SET_CHANGE: function SET_CHANGE(state, payload) {
    state.change = payload;
  },
  SET_RECEIVED_CARD: function SET_RECEIVED_CARD(state, payload) {
    state.receivedMoney.receivedCard = payload;
  },
  SET_RECEIVE_CASH: function SET_RECEIVE_CASH(state, payload) {
    state.receivedMoney.receivedCash = payload;
  },
  CLEAR_MONEY: function CLEAR_MONEY(state) {
    state.receivedMoney.receivedCard = 0;
    state.receivedMoney.receivedCash = 0;
    state.change = 0;
  },
  SET_TIME: function SET_TIME(state, payload) {
    state.time = payload;
  },
  SET_TOTAL: function SET_TOTAL(state) {
    state.total = state.receivedMoney.receivedCash + state.receivedMoney.receivedCard;
  }
};

var getters = {
  getChange: function getChange(state) {
    return state.change;
  },
  getReceivedCash: function getReceivedCash(state) {
    return state.receivedMoney.receivedCash;
  },
  getMemberOrderHistory: function getMemberOrderHistory(state) {
    return state.memberOrderHistory;
  },
  getReceivedCard: function getReceivedCard(state) {
    return state.receivedMoney.receivedCard;
  },
  getOrder: function getOrder(state) {
    return state.order;
  },
  getBillID: function getBillID(state) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.order).length === 0 ? '' : state.order.bill.id;
  },
  getTime: function getTime(state) {
    return state.time;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initDataSetOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


var initDataSetOrder = function initDataSetOrder(payload, state) {
  var tel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var billExpire = arguments[3];

  var cartList = payload.items;
  var price = payload.price;
  var expireDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(parseInt(billExpire), 'd').format('X');
  var skus = transformCartList(cartList);
  var pendingData = createPendingData(state.type, price, tel);
  var paymentLog = createPaymentLog(state.type, state.total, state.change);
  var discount = calDebt(cartList) - price;
  var data = {
    skus: skus,
    debts: [{
      dead_line_date: '',
      debt_balance: price,
      pay_order: 1
    }],
    shipping_type: 'POS',
    discount: discount,
    shipcost: 0,
    bill_expire: parseInt(expireDate),
    pending_data: pendingData,
    pay_order: 1,
    prepare_date: '',
    customer_id: null,
    coupon_id: '',
    unit_id: Object(__WEBPACK_IMPORTED_MODULE_0__utils_helper_localStorage__["h" /* getUnitID */])(),
    store_pos_branch_id: Object(__WEBPACK_IMPORTED_MODULE_0__utils_helper_localStorage__["a" /* getBranchID */])(),
    payment_log: paymentLog,
    promotion_discount: 0,
    promotions: {}
  };

  var result = {
    data: data,
    price: price
  };

  return result;
};

function calDebt(cartList) {
  var total = cartList.reduce(function (sum, item) {
    return sum + parseInt(item.price);
  }, 0);
  return total;
}

function createPendingData(paymentType, price, tel) {
  var pendingData = {
    customer_name: '',
    customer_address: '',
    customer_postcode: '',
    customer_tel: tel,
    customer_email: '',
    payments: [{
      bill_debt_pay_order: 1,
      date: new Date(),
      amount: parseFloat(price).toFixed(2),
      store_payment_channel_id: paymentType.id,
      attached_slip: '',
      cache_payment_channel_name: paymentType.payment_name,
      cache_payment_channel_id: paymentType.payment_channel_id,
      cache_payment_channel_logo: paymentType.logo,
      cache_payment_channel_type: paymentType.payment_name.toLowerCase(),
      cache_store_payment_channel_credential: '{}'
    }]
  };
  return pendingData;
}

function createPaymentLog(paymentType, receivedMoney, change) {
  var paymentLog = {
    recivePayment: parseFloat(receivedMoney).toFixed(2),
    changePayment: parseFloat(change).toFixed(2),
    payments: [{
      id: paymentType.id,
      name: paymentType.payment_name,
      logo: paymentType.logo,
      payment_channel_id: paymentType.payment_channel_id,
      payment_channel_name: paymentType.payment_name,
      payment_channel_type: paymentType.payment_name.toLowerCase(),
      payment_channel_logo: paymentType.logo,
      credential: '{}',
      value: '99'
    }]
  };
  return paymentLog;
}

function transformCartList(cartList) {
  var skus = [];
  cartList.map(function (item) {
    skus.push({
      product_id: item.productId,
      brand_name: '',
      code: '',
      id: item.id,
      price: item.price,
      stock_lot: item.remain,
      skuStatus: '1',
      name: item.name,
      description: '',
      variants: ['SKU', '', ''],
      concat_sku_options: item.optionPOSCompleteCart,
      concatSkuOptions: [],
      sku_src: item.image,
      options: 'default  ',
      warehouse: Object(__WEBPACK_IMPORTED_MODULE_0__utils_helper_localStorage__["k" /* getWerehouse */])(),
      amount: 1,
      discount: {
        type: 'percentageOff',
        value: 10
      },
      fullPrice: item.price,
      isManualDiscount: false
    });
  });
  return skus;
}



/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 119,
	"./af.js": 119,
	"./ar": 120,
	"./ar-dz": 121,
	"./ar-dz.js": 121,
	"./ar-kw": 122,
	"./ar-kw.js": 122,
	"./ar-ly": 123,
	"./ar-ly.js": 123,
	"./ar-ma": 124,
	"./ar-ma.js": 124,
	"./ar-sa": 125,
	"./ar-sa.js": 125,
	"./ar-tn": 126,
	"./ar-tn.js": 126,
	"./ar.js": 120,
	"./az": 127,
	"./az.js": 127,
	"./be": 128,
	"./be.js": 128,
	"./bg": 129,
	"./bg.js": 129,
	"./bm": 130,
	"./bm.js": 130,
	"./bn": 131,
	"./bn-bd": 132,
	"./bn-bd.js": 132,
	"./bn.js": 131,
	"./bo": 133,
	"./bo.js": 133,
	"./br": 134,
	"./br.js": 134,
	"./bs": 135,
	"./bs.js": 135,
	"./ca": 136,
	"./ca.js": 136,
	"./cs": 137,
	"./cs.js": 137,
	"./cv": 138,
	"./cv.js": 138,
	"./cy": 139,
	"./cy.js": 139,
	"./da": 140,
	"./da.js": 140,
	"./de": 141,
	"./de-at": 142,
	"./de-at.js": 142,
	"./de-ch": 143,
	"./de-ch.js": 143,
	"./de.js": 141,
	"./dv": 144,
	"./dv.js": 144,
	"./el": 145,
	"./el.js": 145,
	"./en-au": 146,
	"./en-au.js": 146,
	"./en-ca": 147,
	"./en-ca.js": 147,
	"./en-gb": 148,
	"./en-gb.js": 148,
	"./en-ie": 149,
	"./en-ie.js": 149,
	"./en-il": 150,
	"./en-il.js": 150,
	"./en-in": 151,
	"./en-in.js": 151,
	"./en-nz": 152,
	"./en-nz.js": 152,
	"./en-sg": 153,
	"./en-sg.js": 153,
	"./eo": 154,
	"./eo.js": 154,
	"./es": 155,
	"./es-do": 156,
	"./es-do.js": 156,
	"./es-mx": 157,
	"./es-mx.js": 157,
	"./es-us": 158,
	"./es-us.js": 158,
	"./es.js": 155,
	"./et": 159,
	"./et.js": 159,
	"./eu": 160,
	"./eu.js": 160,
	"./fa": 161,
	"./fa.js": 161,
	"./fi": 162,
	"./fi.js": 162,
	"./fil": 163,
	"./fil.js": 163,
	"./fo": 164,
	"./fo.js": 164,
	"./fr": 165,
	"./fr-ca": 166,
	"./fr-ca.js": 166,
	"./fr-ch": 167,
	"./fr-ch.js": 167,
	"./fr.js": 165,
	"./fy": 168,
	"./fy.js": 168,
	"./ga": 169,
	"./ga.js": 169,
	"./gd": 170,
	"./gd.js": 170,
	"./gl": 171,
	"./gl.js": 171,
	"./gom-deva": 172,
	"./gom-deva.js": 172,
	"./gom-latn": 173,
	"./gom-latn.js": 173,
	"./gu": 174,
	"./gu.js": 174,
	"./he": 175,
	"./he.js": 175,
	"./hi": 176,
	"./hi.js": 176,
	"./hr": 177,
	"./hr.js": 177,
	"./hu": 178,
	"./hu.js": 178,
	"./hy-am": 179,
	"./hy-am.js": 179,
	"./id": 180,
	"./id.js": 180,
	"./is": 181,
	"./is.js": 181,
	"./it": 182,
	"./it-ch": 183,
	"./it-ch.js": 183,
	"./it.js": 182,
	"./ja": 184,
	"./ja.js": 184,
	"./jv": 185,
	"./jv.js": 185,
	"./ka": 186,
	"./ka.js": 186,
	"./kk": 187,
	"./kk.js": 187,
	"./km": 188,
	"./km.js": 188,
	"./kn": 189,
	"./kn.js": 189,
	"./ko": 190,
	"./ko.js": 190,
	"./ku": 191,
	"./ku.js": 191,
	"./ky": 192,
	"./ky.js": 192,
	"./lb": 193,
	"./lb.js": 193,
	"./lo": 194,
	"./lo.js": 194,
	"./lt": 195,
	"./lt.js": 195,
	"./lv": 196,
	"./lv.js": 196,
	"./me": 197,
	"./me.js": 197,
	"./mi": 198,
	"./mi.js": 198,
	"./mk": 199,
	"./mk.js": 199,
	"./ml": 200,
	"./ml.js": 200,
	"./mn": 201,
	"./mn.js": 201,
	"./mr": 202,
	"./mr.js": 202,
	"./ms": 203,
	"./ms-my": 204,
	"./ms-my.js": 204,
	"./ms.js": 203,
	"./mt": 205,
	"./mt.js": 205,
	"./my": 206,
	"./my.js": 206,
	"./nb": 207,
	"./nb.js": 207,
	"./ne": 208,
	"./ne.js": 208,
	"./nl": 209,
	"./nl-be": 210,
	"./nl-be.js": 210,
	"./nl.js": 209,
	"./nn": 211,
	"./nn.js": 211,
	"./oc-lnc": 212,
	"./oc-lnc.js": 212,
	"./pa-in": 213,
	"./pa-in.js": 213,
	"./pl": 214,
	"./pl.js": 214,
	"./pt": 215,
	"./pt-br": 216,
	"./pt-br.js": 216,
	"./pt.js": 215,
	"./ro": 217,
	"./ro.js": 217,
	"./ru": 218,
	"./ru.js": 218,
	"./sd": 219,
	"./sd.js": 219,
	"./se": 220,
	"./se.js": 220,
	"./si": 221,
	"./si.js": 221,
	"./sk": 222,
	"./sk.js": 222,
	"./sl": 223,
	"./sl.js": 223,
	"./sq": 224,
	"./sq.js": 224,
	"./sr": 225,
	"./sr-cyrl": 226,
	"./sr-cyrl.js": 226,
	"./sr.js": 225,
	"./ss": 227,
	"./ss.js": 227,
	"./sv": 228,
	"./sv.js": 228,
	"./sw": 229,
	"./sw.js": 229,
	"./ta": 230,
	"./ta.js": 230,
	"./te": 231,
	"./te.js": 231,
	"./tet": 232,
	"./tet.js": 232,
	"./tg": 233,
	"./tg.js": 233,
	"./th": 234,
	"./th.js": 234,
	"./tk": 235,
	"./tk.js": 235,
	"./tl-ph": 236,
	"./tl-ph.js": 236,
	"./tlh": 237,
	"./tlh.js": 237,
	"./tr": 238,
	"./tr.js": 238,
	"./tzl": 239,
	"./tzl.js": 239,
	"./tzm": 240,
	"./tzm-latn": 241,
	"./tzm-latn.js": 241,
	"./tzm.js": 240,
	"./ug-cn": 242,
	"./ug-cn.js": 242,
	"./uk": 243,
	"./uk.js": 243,
	"./ur": 244,
	"./ur.js": 244,
	"./uz": 245,
	"./uz-latn": 246,
	"./uz-latn.js": 246,
	"./uz.js": 245,
	"./vi": 247,
	"./vi.js": 247,
	"./x-pseudo": 248,
	"./x-pseudo.js": 248,
	"./yo": 249,
	"./yo.js": 249,
	"./zh-cn": 250,
	"./zh-cn.js": 250,
	"./zh-hk": 251,
	"./zh-hk.js": 251,
	"./zh-mo": 252,
	"./zh-mo.js": 252,
	"./zh-tw": 253,
	"./zh-tw.js": 253
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 381;

/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_request__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js__);











var PromotionProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PromotionProvider, _HttpRequest);

  function PromotionProvider() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PromotionProvider);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PromotionProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PromotionProvider)).call(this, '' + "https://camp-stg.herokuapp.com"));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PromotionProvider, [{
    key: 'createOrderHistory',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
        var omsBranch, memberOrderHistoryPayload, newStore, _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                omsBranch = Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])();
                memberOrderHistoryPayload = {
                  order: {
                    shipping_type: payload.order.bill.cache_shipping_type,
                    create_time: payload.order.bill.create_time,
                    currency: {
                      id: 1,
                      name: 'THB'
                    },
                    current_state: 'paid',
                    address: '',
                    country: '',
                    district: '',
                    customer_email: '',
                    customer_name: '',
                    postcode: '',
                    province: '',
                    states: '',
                    contact_no: payload.tel,
                    customer_tel: payload.tel,
                    discount: parseFloat(payload.order.bill.discount),
                    expire: payload.order.bill.expire,
                    id: payload.order.bill.id,
                    net: parseFloat(payload.order.bill.net),
                    note: '',
                    ship_cost: 0,
                    channel_type: 'pos',
                    url: payload.order.bill.url
                  },
                  order_items: payload.items.map(function (item) {
                    var variant1 = item.variant1.toLowerCase();
                    var variant2 = item.variant2.toLowerCase();
                    var color = '';
                    var size = '';
                    if (variant1 === 'color' || variant1 === 'colour') {
                      color = item.option1;
                    } else if (variant2 === 'color' || variant2 === 'colour') {
                      color = item.option2;
                    }

                    if (variant1 === 'size') {
                      size = item.option1;
                    } else if (variant2 === 'size') {
                      size = item.option2;
                    }

                    return {
                      skuId: parseInt(item.id),
                      code: item.code,
                      name: item.name,
                      amount: parseInt(item.amount),
                      color: color,
                      size: 'International:' + size,
                      option: '',
                      description: '',
                      price: parseFloat(item.price),
                      full_price: parseFloat(item.fullPrice),
                      productId: parseInt(item.productId),
                      skuImages: [item.image],
                      photo_urls: [item.image],
                      isOnWeb: true,
                      brand: {
                        id: 2,
                        name: 'a'
                      },
                      warehouse: {
                        id: omsBranch.branch_id,
                        name: omsBranch.warehouse_display_name,
                        code: omsBranch.warehouse
                      },
                      categories: item.categories,
                      tags: item.tags
                    };
                  }),
                  branch: {
                    id: omsBranch.branch_id,
                    name: omsBranch.warehouse_display_name,
                    code: omsBranch.warehouse
                  },
                  cashier: payload.cashier,
                  promotion_code: payload.promotionCode,
                  channel: 'pos'
                };
                _context.prev = 2;
                newStore = __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] ? __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] : '000000000';
                _context.next = 6;
                return this.create('/public/' + newStore.id + '/members/order-history', memberOrderHistoryPayload);

              case 6:
                _ref2 = _context.sent;
                data = _ref2.data;
                return _context.abrupt('return', data);

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](2);

                console.log(_context.t0);
                return _context.abrupt('return', { success: false });

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 11]]);
      }));

      function createOrderHistory(_x) {
        return _ref.apply(this, arguments);
      }

      return createOrderHistory;
    }()
  }]);

  return PromotionProvider;
}(__WEBPACK_IMPORTED_MODULE_7__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PromotionProvider);

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_print_provider__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_new_member_store_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_new_member_store_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_new_member_store_js__);








var printService = new __WEBPACK_IMPORTED_MODULE_5__resources_print_provider__["a" /* default */]();

var state = {
  printer: []
};
var actions = {
  fetchPrinters: function fetchPrinters(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var branchID, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              branchID = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["a" /* getBranchID */])();
              _context.next = 3;
              return printService.getPrinters(branchID);

            case 3:
              res = _context.sent;

              commit('SET_PRINTER', res.data);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  printReceiptAction: function printReceiptAction(_ref2, payload) {
    var _this2 = this;

    var getters = _ref2.getters;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var user, currentBranchPos, newStore, receiptData;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              user = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["i" /* getUser */])();
              currentBranchPos = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])();
              newStore = __WEBPACK_IMPORTED_MODULE_6__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["g" /* getStoreId */])()] ? __WEBPACK_IMPORTED_MODULE_6__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["g" /* getStoreId */])()] : '000000000';
              receiptData = {
                billId: getters.getOrder.bill.id,
                branchPos: {
                  branchId: parseInt(currentBranchPos.branch_id),
                  name: currentBranchPos.name,
                  posId: currentBranchPos.pos_id,
                  taxId: 'TAX#0-1055-61034-56-1',
                  unitId: parseInt(currentBranchPos.unit_id),
                  code: currentBranchPos.warehouse
                },
                payment: {
                  type: getters.getReceivedCard === 0 ? 'cash' : 'credit',
                  receivedCash: parseFloat(getters.getReceivedCash),
                  receivedCredit: parseFloat(getters.getReceivedCard),
                  change: parseFloat(getters.getChange)
                },
                items: getters.getItems.map(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
                    fullPrice: parseFloat(item.fullPrice),
                    price: parseFloat(item.price)
                  });
                }),
                discount: parseFloat(getters.discount),
                print: {
                  message: '',
                  status: 'pending',
                  ip: payload.printerIP
                },
                fullPrice: parseFloat(getters.getFullPrice),
                price: getters.getNetPrice,
                cashier: {
                  id: parseInt(user.id),
                  first_name: user.first_name,
                  last_name: user.last_name
                },
                displayTime: __WEBPACK_IMPORTED_MODULE_3_moment___default()(getters.getTime).format('DD-MM-YYYY HH:mm'),
                member: getters.getMemberOrderHistory.data ? getters.getMemberOrderHistory.data.member : {},
                storeDisplayName: newStore.name,
                storeLogo: 'https://gentlewoman-management.s3-ap-southeast-1.amazonaws.com/receipt-image/gw-logo-shop.png'
              };

              if (payload.printerIP === 'no print') {
                receiptData.print.status = 'no_print';
              }
              _context2.next = 7;
              return printService.printReceipt(receiptData);

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};

var mutations = {
  SET_PRINTER: function SET_PRINTER(state, payload) {
    state.printer = payload;
  }
};

var getters = {
  getPrinters: function getPrinters(state) {
    return state.printer;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_product_provider__ = __webpack_require__(390);




var productProvider = new __WEBPACK_IMPORTED_MODULE_3__resources_product_provider__["a" /* default */]();

var state = {
  products: [],
  searchKey: '',
  productsNumber: 0,
  isLoading: false
};

var actions = {
  initState: function initState(_ref) {
    var commit = _ref.commit;

    commit('INIT_STATE');
  },
  setSearchKey: function setSearchKey(_ref2, payload) {
    var _this = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return productProvider.getProduct(payload);

            case 2:
              data = _context.sent;

              if (!data.productsNumber) {
                _context.next = 9;
                break;
              }

              commit('SET_SEARCH_KEY', payload);
              commit('SET_PRODUCTS', data);
              return _context.abrupt('return', true);

            case 9:
              commit('INIT_STATE');
              return _context.abrupt('return', false);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  loadProductMore: function loadProductMore(_ref3, page) {
    var _this2 = this;

    var commit = _ref3.commit,
        state = _ref3.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return productProvider.getProduct(state.searchKey, page);

            case 2:
              data = _context2.sent;

              commit('ADD_PRODUCTS', data);

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  setIsloading: function setIsloading(_ref4, payload) {
    var commit = _ref4.commit;

    commit('SET_IS_LOADING', payload);
  }
};

var mutations = {
  INIT_STATE: function INIT_STATE(state) {
    state.products = [];
    state.searchKey = '';
    state.productsNumber = 0;
    state.isLoading = false;
  },
  SET_PRODUCTS: function SET_PRODUCTS(state, payload) {
    state.productsNumber = payload.productsNumber;
    if (payload.products) {
      state.products = payload.products;
    }
  },
  ADD_PRODUCTS: function ADD_PRODUCTS(state, payload) {
    state.productsNumber += payload.productsNumber;
    if (payload.products) {
      var _state$products;

      (_state$products = state.products).push.apply(_state$products, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(payload.products));
    }
  },
  SET_SEARCH_KEY: function SET_SEARCH_KEY(state, payload) {
    state.searchKey = payload;
  },
  SET_IS_LOADING: function SET_IS_LOADING(state, payload) {
    state.isLoading = payload;
  }
};

var getters = {
  getProduct: function getProduct(state) {
    return state.products;
  },
  getSearchKey: function getSearchKey(state) {
    return state.searchKey;
  },
  productsNumber: function productsNumber(state) {
    return state.productsNumber;
  },
  getIsLoading: function getIsLoading(state) {
    return state.isLoading;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_request__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__ = __webpack_require__(6);










var ProductProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ProductProvider, _HttpRequest);

  function ProductProvider() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ProductProvider);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProductProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ProductProvider)).call(this, "https://staging-oms-api.akitahub.com"));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ProductProvider, [{
    key: 'getProduct',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(searchKey) {
        var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        var _ref2, data, results;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["f" /* getStoreBearer */])();

              case 3:
                _context.t1 = _context.sent;
                _context.t2 = {
                  'Authorization': _context.t1
                };

                _context.t0.setHeader.call(_context.t0, _context.t2);

                _context.next = 8;
                return this.get('/product', {
                  is_dm: false,
                  page: page,
                  search: searchKey,
                  warehouse: Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["k" /* getWerehouse */])()
                });

              case 8:
                _ref2 = _context.sent;
                data = _ref2.data;
                results = {
                  products: [],
                  productsNumber: 0
                };

                if (!data.results.length) {
                  _context.next = 16;
                  break;
                }

                _context.next = 14;
                return this.tranfromData(data);

              case 14:
                results.products = _context.sent;

                results.productsNumber = data.results.length;

              case 16:
                return _context.abrupt('return', results);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getProduct(_x) {
        return _ref.apply(this, arguments);
      }

      return getProduct;
    }()
  }, {
    key: 'tranfromData',
    value: function tranfromData(data) {
      var result = [];
      try {
        data.results.forEach(function (items) {
          var count = 0;
          var options = items.concat_sku_options.split(':;:');
          var images = items.concat_sku_src.split(':;:');
          var prices = items.concat_sku_price.split(':;:');
          var remain = items.concat_lot_remaining.split(':;:');
          var id = items.concat_sku_id.split(':;:');
          var code = items.concat_sku_code.split(':;:');
          var productId = items.id;
          var name = items.name;
          var tags = items.product_tags === null || !items.product_tags ? [] : items.product_tags.split(':;:');
          var categories = items.concat_product_category === null || !items.concat_product_category ? [] : items.concat_product_category.split(':;:');
          items.concat_sku_code.split(':;:').forEach(function (item) {
            var opt = options[count].split(',');
            result.push({
              productId: productId,
              id: id[count],
              code: code[count],
              name: name,
              tags: tags,
              categories: categories,
              amount: 1,
              option: options[count].replace(/,/g, ' '),
              option1: opt[0],
              option2: opt[1],
              variant1: items.variant_1,
              variant2: items.variant_2,
              optionPOSCompleteCart: options[count].replace(/,,/g, '').replace(/,$/g, ''),
              fullPrice: prices[count],
              price: prices[count],
              image: images[count],
              remain: remain[count],
              quantity: 1
            });
            count++;
          });
        });
      } catch (error) {
        console.log(error);
      }
      return result;
    }
  }]);

  return ProductProvider;
}(__WEBPACK_IMPORTED_MODULE_7__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ProductProvider);

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_sellsuki_provider__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_order_provider__ = __webpack_require__(254);




var orderProvider = new __WEBPACK_IMPORTED_MODULE_3__resources_order_provider__["a" /* default */]();
var sellsukiProvider = new __WEBPACK_IMPORTED_MODULE_2__resources_sellsuki_provider__["a" /* default */]();

var state = {
  sellsukiData: {},
  branch: [],
  initailData: {},
  paymentChannel: [],
  billExpire: 1,
  storeData: {},
  mainColor: '#1b0000'
};

var actions = {
  setSellsukiAuth: function setSellsukiAuth(_ref, payload) {
    var commit = _ref.commit;

    commit('SET_AUTH_SELLSUKI', payload);
  },
  setMainColor: function setMainColor(_ref2, payload) {
    var commit = _ref2.commit;

    commit('SET_MAIN_COLOR', payload);
  },
  fetchBranch: function fetchBranch(_ref3) {
    var _this = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var results;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return sellsukiProvider.fetchBranch();

            case 2:
              results = _context.sent;

              commit('SET_BRANCH', results);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  init: function init(_ref4) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _ref5, billExpire, paymentChannel, initData;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return orderProvider.init();

            case 2:
              _ref5 = _context2.sent;
              billExpire = _ref5.billExpire;
              paymentChannel = _ref5.paymentChannel;
              initData = _ref5.initData;

              commit('SET_INITAIL_DATA', initData);
              commit('SET_PAYMENT_CHANNEL', paymentChannel);
              commit('SET_BILL_EXPIRE', billExpire);

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};

var mutations = {
  SET_MAIN_COLOR: function SET_MAIN_COLOR(state, payload) {
    state.mainColor = payload;
  },
  SET_AUTH_SELLSUKI: function SET_AUTH_SELLSUKI(state, payload) {
    state.sellsukiData = payload;
  },
  SET_BRANCH: function SET_BRANCH(state, payload) {
    state.branch = payload;
  },
  SET_INITAIL_DATA: function SET_INITAIL_DATA(state, payload) {
    state.initailData = payload;
  },
  SET_PAYMENT_CHANNEL: function SET_PAYMENT_CHANNEL(state, payload) {
    state.paymentChannel = payload;
  },
  SET_BILL_EXPIRE: function SET_BILL_EXPIRE(state, payload) {
    state.billExpire = payload;
  }
};

var getters = {
  mainColor: function mainColor(state) {
    return state.mainColor;
  },
  storeName: function storeName(state) {
    return state.initailData.store ? state.initailData.store.store_name : '';
  },
  storeColor: function storeColor(state) {
    return state.initailData.store ? state.initailData.store.store_display_photo : '';
  },
  getSellsukiAuth: function getSellsukiAuth(state) {
    return state.sellsukiData;
  },
  getBranch: function getBranch(state) {
    return state.branch;
  },
  storeId: function storeId(state) {
    return state.initailData.store.id;
  },
  initailData: function initailData(state) {
    return state.initailData;
  },
  storeData: function storeData(state) {
    return state.initailData;
  },
  paymentChannel: function paymentChannel(state) {
    return state.paymentChannel;
  },
  billExpire: function billExpire(state) {
    return state.billExpire;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__http_request__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helper_localStorage__ = __webpack_require__(6);











var SellsukiProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(SellsukiProvider, _HttpRequest);

  function SellsukiProvider() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, SellsukiProvider);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SellsukiProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(SellsukiProvider)).call(this, "https://staging-oms-api.akitahub.com"));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(SellsukiProvider, [{
    key: 'fetchBranch',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        var userCashier, _ref2, results, resultTranformed, result;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = this;
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_9__utils_helper_localStorage__["f" /* getStoreBearer */])();

              case 3:
                _context2.t1 = _context2.sent;
                _context2.t2 = {
                  'Authorization': _context2.t1
                };

                _context2.t0.setHeader.call(_context2.t0, _context2.t2);

                _context2.next = 8;
                return this.getCashier();

              case 8:
                userCashier = _context2.sent;
                _context2.next = 11;
                return this.get('/pos/branch');

              case 11:
                _ref2 = _context2.sent;
                results = _ref2.data.results;
                resultTranformed = this.transformResult(results);
                result = [];

                resultTranformed.map(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(branch) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(userCashier.branchID.findIndex(function (b) {
                              return b === branch.id;
                            }) !== -1)) {
                              _context.next = 3;
                              break;
                            }

                            _context.next = 3;
                            return result.push(branch);

                          case 3:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());
                return _context2.abrupt('return', result);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchBranch() {
        return _ref.apply(this, arguments);
      }

      return fetchBranch;
    }()
  }, {
    key: 'getCashier',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref5, results, result;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = this;
                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_9__utils_helper_localStorage__["f" /* getStoreBearer */])();

              case 3:
                _context3.t1 = _context3.sent;
                _context3.t2 = {
                  'Authorization': _context3.t1
                };

                _context3.t0.setHeader.call(_context3.t0, _context3.t2);

                _context3.next = 8;
                return this.get('/pos/cashier');

              case 8:
                _ref5 = _context3.sent;
                results = _ref5.data.results;
                result = this.mapUserCashier(results);
                return _context3.abrupt('return', result);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCashier() {
        return _ref4.apply(this, arguments);
      }

      return getCashier;
    }()
  }, {
    key: 'mapUserCashier',
    value: function mapUserCashier(results) {
      var loginUser = Object(__WEBPACK_IMPORTED_MODULE_9__utils_helper_localStorage__["i" /* getUser */])();
      var filteredCashier = results.find(function (user) {
        return user.id === loginUser.id;
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filteredCashier, {
        branchID: filteredCashier.concat_cashier_branch_id ? filteredCashier.concat_cashier_branch_id.split(':;:') : [],
        branchName: filteredCashier.concat_cashier_branch_name ? filteredCashier.concat_cashier_branch_name.split(':;:') : []
      });
    }
  }, {
    key: 'transformResult',
    value: function transformResult(results) {
      var data = [];
      results.map(function (item) {
        data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          posID: item.concat_pos_id ? item.concat_pos_id.split(':;:') : [],
          unitID: item.concat_unit_id ? item.concat_unit_id.split(':;:') : [],
          posWarehouse: item.concat_pos_warehouse ? item.concat_pos_warehouse.split(':;:') : [],
          posWarehouseDisplayName: item.concat_pos_warehouse_display_name ? item.concat_pos_warehouse_display_name.split(':;:') : []
        }));
      });
      return data;
    }
  }]);

  return SellsukiProvider;
}(__WEBPACK_IMPORTED_MODULE_8__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SellsukiProvider);

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(44);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('showFullPriceFormat', function () {
  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var str = parseFloat(number).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return str;
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]);

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home_Home__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_home_ScanToSearch__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_cart_Cart__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_check_out_Payment__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_check_out_CheckoutByCash__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_check_out_CheckoutByCard__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_qrcode_reader__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_user_info_UserInfo__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_report_ReportZ__ = __webpack_require__(482);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_qrcode_reader__["default"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_home_Home__["a" /* default */]
  }, {
    path: '/scan-to-search',
    name: 'ScanToSearch',
    component: __WEBPACK_IMPORTED_MODULE_3__views_home_ScanToSearch__["a" /* default */]
  }, {
    path: '/cart',
    name: 'Cart',
    component: __WEBPACK_IMPORTED_MODULE_4__views_cart_Cart__["a" /* default */]
  }, {
    path: '/payment',
    name: 'Payment',
    component: __WEBPACK_IMPORTED_MODULE_5__views_check_out_Payment__["a" /* default */]
  }, {
    path: '/checkout-by-cash',
    name: 'CheckoutByCash',
    component: __WEBPACK_IMPORTED_MODULE_6__views_check_out_CheckoutByCash__["a" /* default */]
  }, {
    path: '/checkout-by-card',
    name: 'CheckoutByCard',
    component: __WEBPACK_IMPORTED_MODULE_7__views_check_out_CheckoutByCard__["a" /* default */]
  }, {
    path: '/user-info',
    name: 'UserInfo',
    component: __WEBPACK_IMPORTED_MODULE_9__views_user_info_UserInfo__["a" /* default */]
  }, {
    path: '/report-z',
    name: 'ReportZ',
    component: __WEBPACK_IMPORTED_MODULE_10__views_report_ReportZ__["a" /* default */]
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd2e005_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(403);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(397)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3dd2e005"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd2e005_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/home/Home.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3dd2e005", Component.options)
  } else {
    hotAPI.reload("data-v-3dd2e005", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(398);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("d727fa8c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3dd2e005\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3dd2e005\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\n.list-item[data-v-3dd2e005] {\n  overflow: auto;\n  height: calc(100vh - 180px);\n}\n.cartItemCount[data-v-3dd2e005] {\n  border-radius: 50%;\n  font-size: 12px;\n}\n.input-data[data-v-3dd2e005] {\n  width: 80%;\n  height: 36px;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #fff;\n  border: solid 1px #1b0000;\n}\n.search[data-v-3dd2e005] {\n  width: 20%;\n  height: 36px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n", ""]);

// exports


/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListProduct_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17ad2cbb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListProduct_vue__ = __webpack_require__(402);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(400)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17ad2cbb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17ad2cbb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/home/ListProduct.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-17ad2cbb", Component.options)
  } else {
    hotAPI.reload("data-v-17ad2cbb", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(401);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("514d76dd", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-17ad2cbb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ListProduct.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-17ad2cbb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ListProduct.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\n.add-item-tab[data-v-17ad2cbb] {\n  width: 100%;\n  height: 48px;\n  background-color: #27cf5a;\n}\n.item-list[data-v-17ad2cbb] {\n  border-bottom: 1px solid;\n  border-color: #cfcfcf;\n}\n.item-amout-box[data-v-17ad2cbb] {\n  width: 88px;\n  height: 36px;\n  border: solid 1px #1b0000;\n  font-size: 18px;\n  font-weight: bold;\n}\n.add-item[data-v-17ad2cbb] {\n  font-size: 24px;\n  font-weight: bold;\n  color: #ffffff;\n  width: 36px;\n  height: 36px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border: solid 1px #1b0000;\n}\n.minus-item[data-v-17ad2cbb] {\n  font-size: 24px;\n  font-weight: bold;\n  color: #ffffff;\n  width: 36px;\n  height: 36px;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border: solid 1px #1b0000;\n}\n", ""]);

// exports


/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.products.length > 1
      ? _c(
          "div",
          _vm._l(_vm.products, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "item-list f-left w-100pct pd-vtc-10px al-center dp-flex al-it-center"
              },
              [
                _c("div", { staticClass: "w-30pct f-left" }, [
                  _c("img", {
                    attrs: { src: item.image, alt: "", width: "60%" }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "w-40pct f-left t-al-left" }, [
                  _c("span", [_c("b", [_vm._v(_vm._s(item.name))])]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  !item.option.includes("default")
                    ? _c("span", [_vm._v(_vm._s(item.option) + " "), _c("br")])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v("In Stock " + _vm._s(item.remain))]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "ราคา ฿ " +
                        _vm._s(_vm._f("showFullPriceFormat")(item.price)) +
                        " "
                    )
                  ]),
                  _vm._v(" "),
                  _c("br")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-30pct f-left" },
                  [
                    _c("svg-filler", {
                      staticClass: "cs-pointer",
                      attrs: {
                        path: "/static/svg/basket.svg",
                        fill: "#1b0000",
                        width: "30px",
                        height: "30px"
                      },
                      on: {
                        click: function($event) {
                          _vm.addItem(item)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          })
        )
      : _vm.products.length === 1
        ? _c("div", [
            _c("img", {
              staticClass: "w-180px",
              attrs: { src: _vm.products[0].image, alt: "" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "f-s-16px f-w-bold" }, [
              _c("span", [_vm._v(_vm._s(_vm.products[0].name))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "f-s-16px pd-16px" }, [
              _c("p", [
                _vm._v("\n        " + _vm._s(_vm.products[0].option1) + " "),
                _c("br"),
                _vm._v(" "),
                _vm.products[0].option2 !== " : "
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.products[0].option2) + " "),
                      _c("br")
                    ])
                  : _vm._e(),
                _vm._v(
                  "\n        stock : " + _vm._s(_vm.products[0].remain) + " "
                ),
                _c("br"),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "Price ฿ " +
                      _vm._s(
                        _vm._f("showFullPriceFormat")(_vm.products[0].price)
                      )
                  )
                ]),
                _vm._v(" "),
                _c("br")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dp-flex jtf-ct-center" }, [
              _c(
                "div",
                {
                  staticClass: "minus-item cs-pointer",
                  style: "background-color: " + _vm.mainColor + ";",
                  on: {
                    click: function($event) {
                      _vm.amountItem--
                    }
                  }
                },
                [_vm._v("\n        -\n      ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "item-amout-box pd-t-6px" }, [
                _vm._v("\n        " + _vm._s(_vm.amountItem) + "\n      ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "add-item cs-pointer",
                  style: "background-color: " + _vm.mainColor + ";",
                  on: {
                    click: function($event) {
                      _vm.amountItem++
                    }
                  }
                },
                [_vm._v("\n        +\n      ")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pd-vtc-16px" }, [
              _c(
                "div",
                {
                  staticClass:
                    "add-item-tab f-s-24px f-w-bold pd-8px cl-white cs-pointer",
                  on: {
                    click: function($event) {
                      _vm.addItemData(_vm.products[0])
                    }
                  }
                },
                [_vm._v("\n        Add To Cart\n      ")]
              )
            ])
          ])
        : _c(
            "div",
            { staticClass: "mg-auto pd-t-100px" },
            [
              _c("svg-filler", {
                attrs: {
                  path: "/static/svg/QR icon big.svg",
                  fill: "#f2f2f2",
                  width: "220px",
                  height: "220px"
                }
              })
            ],
            1
          )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17ad2cbb", esExports)
  }
}

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getBranch()
    ? _c("div", [
        _c(
          "div",
          {
            staticClass:
              "w-100pct h-60px cl-white f-s-18px f-w-bold pd-5px dp-flex al-it-center jtf-ct-center",
            style: "background-color: " + _vm.mainColor + ";"
          },
          [
            _c("span", { staticClass: "mg-l-10px" }, [
              _vm._v(_vm._s(_vm.storeName) + " | " + _vm._s(_vm.branchName))
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "column is-6 is-offset-3 is-paddingless" }, [
          _c(
            "div",
            { staticClass: "columns is-centered is-marginless h-60px" },
            [
              _c("div", { staticClass: "column" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search,
                      expression: "search"
                    }
                  ],
                  staticClass: "input-data f-left pd-6px",
                  attrs: {
                    placeholder: "กรุณาใส่ชื่อสินค้าที่ต้องการค้นหา",
                    type: "search"
                  },
                  domProps: { value: _vm.search },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.search = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "f-left search pd-6px cs-pointer",
                    style: "background-color: " + _vm.mainColor + ";",
                    on: {
                      click: function($event) {
                        _vm.searchData()
                      }
                    }
                  },
                  [
                    _c("svg-filler", {
                      attrs: {
                        path: "/static/svg/search.svg",
                        fill: "#ffffff",
                        width: "20px",
                        height: "20px"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "list-item" }, [
            _c(
              "div",
              [
                _c("ListProduct", {
                  attrs: { products: _vm.products, searchKey: _vm.searchKey },
                  on: {
                    "update:products": function($event) {
                      _vm.products = $event
                    },
                    "update:searchKey": function($event) {
                      _vm.searchKey = $event
                    }
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "w-100pct h-60px cl-white f-s-18px f-w-bold",
            style: "background-color: " + _vm.mainColor + ";"
          },
          [
            _c("div", { staticClass: "columns is-marginless is-paddingless" }, [
              _c(
                "div",
                {
                  staticClass:
                    "column is-paddingless is-6 is-offset-3 dp-flex jtf-ct-space-between"
                },
                [
                  _c(
                    "div",
                    { staticClass: "pd-16px" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "UserInfo" }, exact: "" } },
                        [
                          _c("svg-filler", {
                            attrs: {
                              path: "/static/svg/user.svg",
                              fill: "#ffffff",
                              width: "24px",
                              height: "24px"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pd-6px" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "ScanToSearch" }, exact: "" } },
                        [
                          _c("svg-filler", {
                            attrs: {
                              path: "/static/svg/QR_icon.svg",
                              fill: "#ffffff",
                              width: "48px",
                              height: "48px"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pd-r-20px" },
                    [
                      _vm.amount === 0
                        ? _c("svg-filler", {
                            staticClass: "mg-t-16px",
                            attrs: {
                              path: "/static/svg/basket.svg",
                              fill: "#ffffff",
                              width: "24px",
                              height: "24px"
                            }
                          })
                        : _c(
                            "router-link",
                            { attrs: { to: { name: "Cart" }, exact: "" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "tag cartItemCount is-danger pst-absolute mg-l-15px mg-t-8px"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.amount) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("svg-filler", {
                                staticClass: "mg-t-16px",
                                attrs: {
                                  path: "/static/svg/basket.svg",
                                  fill: "#ffffff",
                                  width: "24px",
                                  height: "24px"
                                }
                              })
                            ],
                            1
                          )
                    ],
                    1
                  )
                ]
              )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dd2e005", esExports)
  }
}

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanToSearch_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9212b74_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScanToSearch_vue__ = __webpack_require__(408);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(405)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d9212b74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanToSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9212b74_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScanToSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/home/ScanToSearch.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d9212b74", Component.options)
  } else {
    hotAPI.reload("data-v-d9212b74", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(406);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("4679f72c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d9212b74\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ScanToSearch.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d9212b74\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ScanToSearch.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\n.list-item[data-v-d9212b74] {\n  overflow: auto;\n  height: calc(100vh - 60px);\n}\n.qrcode[data-v-d9212b74]{\n  width:300px;\n  height:300px;\n  border: 3px solid black;\n}\n", ""]);

// exports


/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tid.53d97f3.mp3";

/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",
        style: "background-color: " + _vm.mainColor + ";"
      },
      [
        _c(
          "router-link",
          { attrs: { to: { name: "Home" } } },
          [
            _c("svg-filler", {
              staticClass: "mg-r-auto f-left cs-pointer",
              attrs: {
                path: "/static/svg/back.svg",
                fill: "#ffffff",
                width: "20px",
                height: "20px"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("span", [_vm._v("\n      Scan QR code\n    ")])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "list-item" }, [
      _c(
        "div",
        {
          staticClass:
            "pst-fixed mg-auto t-0px l-0px r-0px bt-0px w-fit-content h-fit-content t-al-center "
        },
        [
          _c("qrcode-reader", {
            staticClass: "qrcode",
            on: { decode: _vm.onDecode }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9212b74", esExports)
  }
}

/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb050a5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__(462);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(410)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fb050a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb050a5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/cart/Cart.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7fb050a5", Component.options)
  } else {
    hotAPI.reload("data-v-7fb050a5", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(411);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("c43a8d44", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7fb050a5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Cart.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7fb050a5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Cart.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\n.clear-item[data-v-7fb050a5] {\n  font-size: 0.75rem;\n  width: 160px;\n  height: 36px;\n  border-radius: 4px;\n  background-color: #f83c3c;\n  border: solid 1px #e5e5e5;\n}\n.input-data[data-v-7fb050a5] {\n  width: 75%;\n  height: 36px;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #ffffff;\n  border: solid 1px #1b0000;\n}\n.list-item[data-v-7fb050a5] {\n  overflow: auto;\n  height: calc(100vh - 360px);\n}\n.search[data-v-7fb050a5] {\n  width: 25%;\n  height: 36px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.cart-data[data-v-7fb050a5] {\n  height: 300px;\n  background-color: #f2f2f2;\n}\n.add-item-btn[data-v-7fb050a5] {\n  font-size: 0.75rem;\n  color: #ffffff;\n  padding: 0.6rem;\n  width: 30%;\n  height: 36px;\n  border-radius: 4px;\n}\n.checkout-btn[data-v-7fb050a5] {\n  height: 36px;\n  width: 65%;\n  color: #ffffff;\n  font-size: 0.75rem;\n  padding: 0.6rem;\n  float: left;\n  margin-left: 16px;\n  border-radius: 4px;\n  background-color: #27cf5a;\n}\n.summary-price[data-v-7fb050a5] {\n  text-align: right;\n  border-bottom: 1px solid #d2d2d2;\n}\n", ""]);

// exports


/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListCart_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9a6ae3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListCart_vue__ = __webpack_require__(415);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(413)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b9a6ae3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9a6ae3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/cart/ListCart.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b9a6ae3a", Component.options)
  } else {
    hotAPI.reload("data-v-b9a6ae3a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(414);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("44000170", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b9a6ae3a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ListCart.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b9a6ae3a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ListCart.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\n.item-list[data-v-b9a6ae3a] {\n  border-bottom: 1px solid;\n  border-color: #cfcfcf;\n}\n.remove-icon[data-v-b9a6ae3a] {\n  color: #d2d2d2;\n}\n", ""]);

// exports


/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100pct" },
    _vm._l(_vm.items, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "item-list f-left w-100pct pd-vtc-10px al-center"
        },
        [
          _c("div", { staticClass: "w-15pct f-left" }, [
            _c("img", { attrs: { src: item.image, alt: "", width: "100%" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-85pct f-left t-al-left pd-l-10px" }, [
            _c("div", [
              _c("span", { staticClass: "f-s-16px f-w-bold" }, [
                _vm._v(_vm._s(item.name) + " (" + _vm._s(item.code) + ") ")
              ])
            ]),
            _vm._v(" "),
            _c("div", [_c("span", {}, [_vm._v(_vm._s(item.option))])]),
            _vm._v(" "),
            _c("div", { staticClass: "dp-flex jtf-ct-space-between" }, [
              _c("div", { staticClass: "w-80pct" }, [
                _vm._v(
                  "\n          ฿ " +
                    _vm._s(_vm._f("showFullPriceFormat")(item.price)) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "w-20pct" },
                [
                  _c("svg-filler", {
                    staticClass: "cs-pointer",
                    attrs: {
                      path: "/static/svg/trash-alt-regular.svg",
                      fill: "#1b0000",
                      width: "20px",
                      height: "20px"
                    },
                    on: {
                      click: function($event) {
                        _vm.confirmCustomDelete(item)
                      }
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9a6ae3a", esExports)
  }
}

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",
        style: "background-color: " + _vm.mainColor + ";"
      },
      [
        _c(
          "router-link",
          { attrs: { to: { name: "Home" } } },
          [
            _c("svg-filler", {
              staticClass: "mg-r-auto f-left cs-pointer",
              attrs: {
                path: "/static/svg/back.svg",
                fill: "#ffffff",
                width: "20px",
                height: "20px"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "\n      มีสินค้าในตระกร้าจำนวน " +
              _vm._s(_vm.amount) +
              " ชิ้น\n    "
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "columns is-marginless is-centered" }, [
      _c(
        "div",
        { staticClass: "list-item column is-6 is-marginless pd-20px" },
        [
          _c(
            "div",
            { staticClass: "columns is-marginless is-paddingless" },
            [
              _c("list-cart", {
                attrs: { items: _vm.items },
                on: { clearPromotionCode: _vm.clearPromotionCode }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "columns is-marginless is-paddingless f-left w-100pct"
            },
            [
              _c("div", { staticClass: "column is-6 is-offset-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "mg-auto clear-item mg-hrzt-auto cl-white f-w-bold pd-6px cs-pointer",
                    on: {
                      click: function($event) {
                        _vm.clear()
                      }
                    }
                  },
                  [_vm._v("ล้างรายการ")]
                )
              ])
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cart-data columns is-marginless is-centered" }, [
      _c("div", { staticClass: "column is-6 is-marginless pd-20px" }, [
        _c("div", { staticClass: "f-s-16px f-w-bold t-al-left" }, [
          _vm._v("\n        เบอร์โทรศัพท์\n      ")
        ]),
        _vm._v(" "),
        !_vm.isTel
          ? _c(
              "div",
              [
                _c("VueTelInput", {
                  staticClass: "input-data f-left pd-6px",
                  attrs: { preferredCountries: ["us", "gb", "ua", "th"] },
                  on: { onInput: _vm.onInputTel },
                  model: {
                    value: _vm.tel,
                    callback: function($$v) {
                      _vm.tel = $$v
                    },
                    expression: "tel"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "f-left cl-light f-w-bold search pd-6px cs-pointer",
                    style: "background-color: " + _vm.mainColor + ";",
                    on: {
                      click: function($event) {
                        _vm.setMemberTel()
                      }
                    }
                  },
                  [_vm._v("\n          confirm\n        ")]
                )
              ],
              1
            )
          : _c(
              "div",
              [
                _c("VueTelInput", {
                  staticClass: "input-data f-left pd-6px",
                  attrs: { disabled: true },
                  model: {
                    value: _vm.tel,
                    callback: function($$v) {
                      _vm.tel = $$v
                    },
                    expression: "tel"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "f-left pd-6px cs-pointer search cl-light f-w-bold",
                    style: "background-color: " + _vm.mainColor + ";",
                    on: {
                      click: function($event) {
                        _vm.changTel()
                      }
                    }
                  },
                  [_vm._v("\n          Clear\n        ")]
                )
              ],
              1
            ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("div", { staticClass: "f-s-16px f-w-bold t-al-left" }, [
          _vm._v("\n        รหัสส่วนลดพิเศษ \n      ")
        ]),
        _vm._v(" "),
        !_vm.isCode
          ? _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.promoCode,
                    expression: "promoCode"
                  }
                ],
                staticClass: "input-data f-left pd-6px",
                attrs: { placeholder: "A-1234" },
                domProps: { value: _vm.promoCode },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.promoCode = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "f-left search pd-6px cs-pointer",
                  style: "background-color: " + _vm.mainColor + ";",
                  on: {
                    click: function($event) {
                      _vm.verifyCode()
                    }
                  }
                },
                [
                  _c("svg-filler", {
                    attrs: {
                      path: "/static/svg/search.svg",
                      fill: "#ffffff",
                      width: "20px",
                      height: "20px"
                    }
                  })
                ],
                1
              )
            ])
          : _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.promoCode,
                    expression: "promoCode"
                  }
                ],
                staticClass: "input-data f-left pd-6px",
                attrs: { placeholder: "A-1234", disabled: "disabled" },
                domProps: { value: _vm.promoCode },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.promoCode = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "f-left search pd-6px cs-pointer cl-light f-w-bold",
                  style: "background-color: " + _vm.mainColor + ";",
                  on: {
                    click: function($event) {
                      _vm.changCode()
                    }
                  }
                },
                [_vm._v("\n          Clear\n        ")]
              )
            ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dp-flex jtf-ct-space-between f-s-16px f-w-bold" },
          [
            _c("div", { staticClass: "w-50pct t-al-left" }, [
              _vm._v("\n          ราคารวม\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w-50pct t-al-right" }, [
              _vm._v(
                "\n          ฿ " +
                  _vm._s(_vm._f("showFullPriceFormat")(_vm.getFullPrice)) +
                  "\n        "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dp-flex jtf-ct-space-between f-s-16px f-w-bold" },
          [
            _c("div", { staticClass: "w-80pct t-al-left" }, [
              _vm._v("\n          ส่วนลดพิเศษ\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w-50pct t-al-right" }, [
              _vm._v("\n          ฿ "),
              _vm.discount > 0 ? _c("span", [_vm._v("-")]) : _vm._e(),
              _vm._v(
                _vm._s(_vm._f("showFullPriceFormat")(_vm.discount)) +
                  "\n        "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dp-flex jtf-ct-space-between f-s-16px f-w-bold" },
          [
            _c("div", { staticClass: "w-50pct t-al-left" }, [
              _vm._v("\n          ราคาสุทธิ\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w-50pct t-al-right" }, [
              _vm._v(
                "\n          ฿ " +
                  _vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice)) +
                  "\n        "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "dp-flex jtf-ct-space-between f-w-bold" }, [
          _c(
            "div",
            {
              staticClass: "add-item-btn cs-pointer",
              style: "background-color: " + _vm.mainColor + ";",
              on: {
                click: function($event) {
                  _vm.$router.push({ name: "ScanToSearch" })
                }
              }
            },
            [_vm._v("\n          + เพิ่มสินค้า\n        ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "checkout-btn cs-pointer",
              on: {
                click: function($event) {
                  _vm.confirm()
                }
              }
            },
            [
              _vm._v(
                "\n          ชำระเงิน (" +
                  _vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice)) +
                  " ฿)\n        "
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fb050a5", esExports)
  }
}

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_129e8794_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(464);
var disposed = false
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_129e8794_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/check-out/Payment.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-129e8794", Component.options)
  } else {
    hotAPI.reload("data-v-129e8794", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",
        style: "background-color: " + _vm.mainColor + ";"
      },
      [
        _c(
          "router-link",
          { attrs: { to: { name: "Cart" } } },
          [
            _c("svg-filler", {
              staticClass: "mg-r-auto f-left cs-pointer",
              attrs: {
                path: "/static/svg/back.svg",
                fill: "#ffffff",
                width: "20px",
                height: "20px"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("span", [_vm._v("\n      ช่องทางการชำระเงิน\n    ")])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "w-100pct h-60calc" }, [
      _c("div", { staticClass: "t-al-center f-s-24px f-w-bold pd-t-48px" }, [
        _vm._v(
          "\n      ราคา " +
            _vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice)) +
            " บาท\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "t-al-center f-s-18px mg-t-48px" },
        [
          _c("router-link", { attrs: { to: { name: "CheckoutByCard" } } }, [
            _c("img", {
              staticClass: "w-174px",
              attrs: { src: "/static/svg/credit.svg" }
            }),
            _vm._v(" "),
            _c("br")
          ]),
          _vm._v("\n      ชำระด้วยบัตรเครดิต\n    ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "t-al-center f-s-18px mg-t-48px" },
        [
          _c("router-link", { attrs: { to: { name: "CheckoutByCash" } } }, [
            _c("img", {
              staticClass: "w-174px",
              attrs: { src: "/static/svg/cash.svg" }
            }),
            _vm._v(" "),
            _c("br")
          ]),
          _vm._v("\n      ชำระด้วยเงินสด\n    ")
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-129e8794", esExports)
  }
}

/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckoutByCash_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34816a10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckoutByCash_vue__ = __webpack_require__(471);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(466)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34816a10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckoutByCash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34816a10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckoutByCash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/check-out/CheckoutByCash.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-34816a10", Component.options)
  } else {
    hotAPI.reload("data-v-34816a10", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(467);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("6c66723f", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-34816a10\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CheckoutByCash.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-34816a10\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CheckoutByCash.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\n.checkout-btn[data-v-34816a10] {\n  width: 160px;\n  height: 36px;\n  border-radius: 4px;\n  border: solid 1px #e5e5e5;\n  color: #ffffff;\n}\n.price-btn[data-v-34816a10] {\n  width: 53px;\n  height: 36px;\n  border-radius: 4px;\n  background-color: #ffffff;\n}\n.price-inp[data-v-34816a10] {\n  width: 152px;\n  height: 36px;\n  /* border-radius: 4px; */\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #ffffff;\n  border: solid 1px #e5e5e5;\n}\n.calculate-price-btn[data-v-34816a10] {\n  width: 36px;\n  height: 36px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background-color: #1b0000;\n}\n.input[data-v-34816a10]::-webkit-outer-spin-button,\n.input[data-v-34816a10]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n", ""]);

// exports


/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(469);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("55a081a0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4516a6f6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SelectPrinter.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4516a6f6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SelectPrinter.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\n.printer[data-v-4516a6f6] {\n  height: 60px;\n  border-radius: 4px;\n  background-color: #1b0000;\n  border: solid 1px #1b0000;\n  color: #ffffff;\n}\n.no-print[data-v-4516a6f6] {\n  height: 60px;\n  border-radius: 4px;\n  background-color: #ffffff;\n  border: solid 1px #1b0000;\n}\n.body-box[data-v-4516a6f6] {\n  border-radius: 4px;\n}\n.receive[data-v-4516a6f6] {\n  margin-bottom: 5px;\n}\n", ""]);

// exports


/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-cl-white body-box" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "columns is-marginless is-paddingless is-centered bd-rd-4px"
      },
      [
        _c(
          "div",
          { staticClass: "column is-4" },
          [
            _vm._l(_vm.printers, function(printer, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "printer mg-10px pd-6px f-w-bold t-al-center cs-pointer",
                  style: "background-color: " + _vm.mainColor + ";",
                  on: {
                    click: function($event) {
                      _vm.finishPrint(printer.ip)
                    }
                  }
                },
                [
                  _vm._v("\n        " + _vm._s(printer.name) + " "),
                  _c("br"),
                  _vm._v(" " + _vm._s(printer.ip) + "\n      ")
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "no-print mg-10px pd-18px f-w-bold cs-pointer",
                on: {
                  click: function($event) {
                    _vm.finishPrint("no print")
                  }
                }
              },
              [_vm._v("\n        ไม่พิมพ์ใบเสร็จ\n      ")]
            )
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "w-100pct h-60px bg-cl-light cl-black f-s-22px f-w-bold pd-18px t-al-center"
      },
      [_c("span", [_vm._v("\n      พิมพ์ใบเสร็จ\n    ")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4516a6f6", esExports)
  }
}

/***/ }),

/***/ 471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",
            style: "background-color: " + _vm.mainColor + ";"
          },
          [
            _c(
              "router-link",
              { attrs: { to: { name: "Payment" } } },
              [
                _c("svg-filler", {
                  staticClass: "mg-r-auto f-left cs-pointer",
                  attrs: {
                    path: "/static/svg/back.svg",
                    fill: "#ffffff",
                    width: "20px",
                    height: "20px"
                  },
                  on: {
                    click: function($event) {
                      _vm.clear()
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("span", [_vm._v("\n        ชำระเงินด้วยเงินสด\n      ")])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "w-100pct h-60calc" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-23px f-s-16px f-w-bold" }, [
            _c("span", [
              _vm._v(
                "ยอดที่ต้องชำระ ฿ " +
                  _vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice))
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-16px f-s-14px" }, [
            _vm._v("\n        ใส่จำนวนเงินที่ได้รับ\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-8px f-s-14px w-300px mg-auto" }, [
            _c(
              "div",
              {
                staticClass: "price-btn pd-8px cs-pointer mg-l-7px f-left",
                on: {
                  click: function($event) {
                    _vm.addReceive(1000)
                  }
                }
              },
              [_vm._v("\n          1,000\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "price-btn pd-8px cs-pointer mg-l-7px f-left",
                on: {
                  click: function($event) {
                    _vm.addReceive(2000)
                  }
                }
              },
              [_vm._v("\n          2,000\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "price-btn pd-8px cs-pointer mg-l-7px f-left",
                on: {
                  click: function($event) {
                    _vm.addReceive(3000)
                  }
                }
              },
              [_vm._v("\n          3,000\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "price-btn pd-8px cs-pointer mg-l-7px f-left",
                on: {
                  click: function($event) {
                    _vm.addReceive(5000)
                  }
                }
              },
              [_vm._v("\n          5,000\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "price-btn pd-8px cs-pointer mg-l-7px f-left",
                on: {
                  click: function($event) {
                    _vm.clear()
                  }
                }
              },
              [_vm._v("\n          Clear\n        ")]
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "pd-t-8px f-s-14px w-190px mg-auto" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.receive,
                  expression: "receive"
                }
              ],
              staticClass: "price-inp pd-6px f-left",
              attrs: { type: "number", placeholder: "0,000", min: "0" },
              domProps: { value: _vm.receive },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.receive = $event.target.value
                  },
                  function($event) {
                    _vm.calculatedChange({
                      receive: _vm.receive,
                      netPrice: _vm.netPrice
                    })
                  }
                ]
              }
            })
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-10px f-s-16px f-w-bold" }, [
            _vm._v("\n        จำนวนเงินทอน "),
            _c("br"),
            _vm._v(
              "\n        ฿ " +
                _vm._s(_vm._f("showFullPriceFormat")(_vm.change)) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-13px f-s-16px f-w-bold" }, [
            _vm.receivedCash < _vm.netPrice || _vm.fullPrice === 0
              ? _c(
                  "div",
                  {
                    staticClass: "checkout-btn cs-not-allowed mg-auto pd-8px",
                    style: "background-color: " + _vm.mainColor + ";"
                  },
                  [_vm._v(" ชำระเงินเสร็จสิ้น ")]
                )
              : _c(
                  "div",
                  {
                    staticClass: "checkout-btn cs-pointer mg-auto pd-8px",
                    style: "background-color: " + _vm.mainColor + ";",
                    on: {
                      click: function($event) {
                        _vm.finishCheckout("Cash")
                      }
                    }
                  },
                  [_vm._v(" ชำระเงินเสร็จสิ้น ")]
                )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.activeModal, canCancel: [] },
          on: {
            "update:active": function($event) {
              _vm.activeModal = $event
            }
          }
        },
        [_c("SelectPrinter")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pd-t-13px" }, [
      _c("img", {
        staticClass: "w-78px",
        attrs: { src: "/static/img/icons/apple-touch-icon-180x180.png" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34816a10", esExports)
  }
}

/***/ }),

/***/ 472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckoutByCard_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3294336d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckoutByCard_vue__ = __webpack_require__(475);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(473)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3294336d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckoutByCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3294336d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckoutByCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/check-out/CheckoutByCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3294336d", Component.options)
  } else {
    hotAPI.reload("data-v-3294336d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(474);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("42321b03", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3294336d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CheckoutByCard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3294336d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CheckoutByCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\n.checkout-btn[data-v-3294336d] {\n  width: 160px;\n  height: 36px;\n  border-radius: 4px;\n  border: solid 1px #e5e5e5;\n  color: #ffffff;\n}\n", ""]);

// exports


/***/ }),

/***/ 475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",
            style: "background-color: " + _vm.mainColor + ";"
          },
          [
            _c(
              "router-link",
              { attrs: { to: { name: "Payment" } } },
              [
                _c("svg-filler", {
                  staticClass: "mg-r-auto f-left cs-pointer",
                  attrs: {
                    path: "/static/svg/back.svg",
                    fill: "#ffffff",
                    width: "20px",
                    height: "20px"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("span", [_vm._v("\n        ชำระเงินด้วยบัตรเครดิต\n      ")])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "w-100pct h-60calc" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-23px f-s-16px f-w-bold" }, [
            _c("span", [
              _vm._v(
                "ยอดที่ต้องชำระ ฿ " +
                  _vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice))
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-23px f-s-16px f-w-bold" }, [
            _vm.fullPrice === 0
              ? _c(
                  "div",
                  {
                    staticClass: "checkout-btn cs-not-allowed mg-auto pd-8px",
                    style: "background-color: " + _vm.mainColor + ";"
                  },
                  [_vm._v(" ชำระเงินเสร็จสิ้น ")]
                )
              : _c(
                  "div",
                  {
                    staticClass: "checkout-btn cs-pointer mg-auto pd-8px",
                    style: "background-color: " + _vm.mainColor + ";",
                    on: {
                      click: function($event) {
                        _vm.finishCheckout("Credit")
                      }
                    }
                  },
                  [_vm._v(" ชำระเงินเสร็จสิ้น ")]
                )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.activeModal, canCancel: [] },
          on: {
            "update:active": function($event) {
              _vm.activeModal = $event
            }
          }
        },
        [_c("SelectPrinter")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pd-t-23px" }, [
      _c("img", {
        staticClass: "w-78px",
        attrs: { src: "/static/img/icons/apple-touch-icon-180x180.png" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3294336d", esExports)
  }
}

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInfo_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1abdedc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__ = __webpack_require__(481);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(479)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b1abdedc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1abdedc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/user-info/UserInfo.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b1abdedc", Component.options)
  } else {
    hotAPI.reload("data-v-b1abdedc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(480);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("6512e538", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b1abdedc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserInfo.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b1abdedc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserInfo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\n.reportZ-btn[data-v-b1abdedc] {\n  width: 210px;\n  height: 36px;\n  border-radius: 4px;\n  border: solid 0.5px #e5e5e5;\n}\n.logOut-btn[data-v-b1abdedc] {\n  width: 210px;\n  height: 36px;\n  border-radius: 4px;\n  background-color: #ffffff;\n  border: solid 1px #1b0000;\n}\n", ""]);

// exports


/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",
          style: "background-color: " + _vm.mainColor + ";"
        },
        [
          _c(
            "router-link",
            { attrs: { to: { name: "Home" } } },
            [
              _c("svg-filler", {
                staticClass: "mg-r-auto f-left cs-pointer",
                attrs: {
                  path: "/static/svg/back.svg",
                  fill: "#ffffff",
                  width: "20px",
                  height: "20px"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(" ข้อมูลของฉัน ")])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "w-100pct h-60calc" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "t-al-center f-s-18px f-w-bold" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.userInfo.user.first_name) +
              "  " +
              _vm._s(_vm.userInfo.user.last_name) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "table",
          { staticClass: "table t-al-center f-s-18px mg-auto pd-hrzt-10px" },
          [
            _c("tr", [
              _c("td", [_vm._v(" EmpNo. ")]),
              _vm._v(" "),
              _c("td", [_vm._v(" " + _vm._s(_vm.userInfo.user.id) + " ")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v(" Branch name ")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(" " + _vm._s(_vm.userInfo.user.branch_name) + " ")
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v(" POS ID ")]),
              _vm._v(" "),
              _c("td", [_vm._v(" " + _vm._s(_vm.userInfo.user.pos_id) + " ")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("\n            E-mail\n          ")]),
              _vm._v(" "),
              _c("td", [_vm._v(" " + _vm._s(_vm.userInfo.user.email) + " ")])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "t-al-center mg-t-16px" },
          [
            _c(
              "router-link",
              { attrs: { to: { name: "ReportZ" }, exact: "" } },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "reportZ-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px cl-white",
                    style: "background-color: " + _vm.mainColor + ";"
                  },
                  [_vm._v(" รายงานสรุปยอดประจำวัน ")]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "t-al-center mg-t-16px" }, [
          _c(
            "div",
            {
              staticClass:
                "reportZ-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px cl-white",
              style: "background-color: " + _vm.mainColor + ";",
              on: {
                click: function($event) {
                  _vm.changeBranch()
                }
              }
            },
            [_vm._v(" เปลี่ยนสาขา ")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "t-al-center mg-t-21px" }, [
          _c(
            "div",
            {
              staticClass:
                "logOut-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px",
              on: {
                click: function($event) {
                  _vm.logout()
                }
              }
            },
            [_vm._v(" ออกจากระบบ ")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.activeModal, canCancel: [] },
          on: {
            "update:active": function($event) {
              _vm.activeModal = $event
            },
            close: function($event) {
              _vm.getBranchNameDisplay()
            }
          }
        },
        [_c("selectStore", { attrs: { cancelBtn: true } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "t-al-center" }, [
      _c("img", {
        staticStyle: { width: "228px" },
        attrs: { src: "/static/img/image/sellsuki.PNG" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1abdedc", esExports)
  }
}

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportZ_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31616276_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportZ_vue__ = __webpack_require__(486);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(483)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31616276"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportZ_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31616276_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportZ_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/report/ReportZ.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-31616276", Component.options)
  } else {
    hotAPI.reload("data-v-31616276", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(484);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("f9bece50", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31616276\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ReportZ.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31616276\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ReportZ.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\n.print-btn[data-v-31616276] {\n  width: 210px;\n  height: 36px;\n  border-radius: 4px;\n  background-color: #1b0000;\n  border: solid 0.5px #e5e5e5;\n  color:white;\n}\n.disabled[data-v-31616276] {\n  width: 210px;\n  height: 36px;\n  border-radius: 4px;\n  background-color: #1b00009c;\n  border: solid 0.5px #e5e5e5;\n  color:white;\n}\n", ""]);

// exports


/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_request__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);











var ReportProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ReportProvider, _HttpRequest);

  function ReportProvider() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ReportProvider);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ReportProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ReportProvider)).call(this, "https://staging-oms-api.akitahub.com"));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ReportProvider, [{
    key: 'getReportZ',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(date) {
        var _ref2, results;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["f" /* getStoreBearer */])();

              case 3:
                _context.t1 = _context.sent;
                _context.t2 = {
                  'Authorization': _context.t1
                };

                _context.t0.setHeader.call(_context.t0, _context.t2);

                _context.next = 8;
                return this.get('/pos/report-z', {
                  date: date,
                  pos_unit_id: Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["h" /* getUnitID */])()
                });

              case 8:
                _ref2 = _context.sent;
                results = _ref2.data.results;


                if (results.last_bill.length !== 0) {
                  results.last_bill[0].create_time = __WEBPACK_IMPORTED_MODULE_9_moment___default()(results.last_bill[0].create_time).add(7, 'hours').format('DD-MM-YYYY HH:mm');
                }
                if (results.first_bill.length !== 0) {
                  results.first_bill[0].create_time = __WEBPACK_IMPORTED_MODULE_9_moment___default()(results.first_bill[0].create_time).add(7, 'hours').format('DD-MM-YYYY HH:mm');
                }
                return _context.abrupt('return', results);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getReportZ(_x) {
        return _ref.apply(this, arguments);
      }

      return getReportZ;
    }()
  }]);

  return ReportProvider;
}(__WEBPACK_IMPORTED_MODULE_7__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ReportProvider);

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",
        style: "background-color: " + _vm.mainColor + ";"
      },
      [
        _c(
          "router-link",
          { attrs: { to: { name: "UserInfo" } } },
          [
            _c("svg-filler", {
              staticClass: "mg-r-auto f-left cs-pointer",
              attrs: {
                path: "/static/svg/back.svg",
                fill: "#ffffff",
                width: "20px",
                height: "20px"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("span", [_vm._v("\n      รายงานสรุปยอดประจำวัน\n    ")])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "columns is-centered is-marginless" }, [
      _c(
        "div",
        { staticClass: "h-60calc mg-t-16px pd-hrzt-35px column is-4" },
        [
          _c("div", { staticClass: "dp-flex jtf-ct-space-between " }, [
            _c("div", { staticClass: "f-left f-s-14px f-w-bold" }, [
              _vm._v("เลือกวันที่")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "f-right w-62pct" },
              [
                _c("b-datepicker", {
                  attrs: {
                    placeholder: "เลือกวันที่ ที่ต้องการพิมพ์",
                    icon: "calendar-today",
                    "max-date": _vm.maxDate
                  },
                  model: {
                    value: _vm.selectedDate,
                    callback: function($$v) {
                      _vm.selectedDate = $$v
                    },
                    expression: "selectedDate"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dp-flex jtf-ct-space-between mg-t-16px" }, [
            _c("div", { staticClass: "f-left f-s-14px f-w-bold" }, [
              _vm._v("เงินตั้งต้น")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "f-right w-62pct" },
              [
                _c("b-input", {
                  attrs: { type: "number", min: "0" },
                  model: {
                    value: _vm.startPrice,
                    callback: function($$v) {
                      _vm.startPrice = $$v
                    },
                    expression: "startPrice"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dp-flex jtf-ct-space-between mg-t-16px" }, [
            _c("div", { staticClass: "f-left f-s-14px f-w-bold" }, [
              _vm._v("ยอดงานนำส่ง")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "f-right w-62pct" },
              [
                _c("b-input", {
                  attrs: { type: "number", min: "0" },
                  model: {
                    value: _vm.givePrice,
                    callback: function($$v) {
                      _vm.givePrice = $$v
                    },
                    expression: "givePrice"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dp-flex jtf-ct-space-between mg-t-16px" }, [
            _c("div", { staticClass: "f-left f-s-14px f-w-bold" }, [
              _vm._v("เครื่องปริ้น")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "f-right w-62pct" },
              [
                _c(
                  "b-select",
                  {
                    attrs: { expanded: "", placeholder: "เลือก Printer" },
                    model: {
                      value: _vm.selectedPrinter,
                      callback: function($$v) {
                        _vm.selectedPrinter = $$v
                      },
                      expression: "selectedPrinter"
                    }
                  },
                  _vm._l(_vm.printers, function(printer, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: printer.ip } },
                      [_vm._v(_vm._s(printer.name))]
                    )
                  })
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns is-marginless" }, [
            _vm.startPrice === "" ||
            _vm.startPrice === "0" ||
            (_vm.givePrice === "" || _vm.givePrice === "0") ||
            _vm.selectedPrinter === ""
              ? _c(
                  "div",
                  {
                    staticClass:
                      "disabled mg-auto pd-vtc-5px pd-hrzt-2px mg-t-16px"
                  },
                  [_vm._v(" พิมพ์รายงาน ")]
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "print-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px mg-t-16px",
                    style: "background-color: " + _vm.mainColor + ";",
                    on: {
                      click: function($event) {
                        _vm.print()
                      }
                    }
                  },
                  [_vm._v(" พิมพ์รายงาน ")]
                )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31616276", esExports)
  }
}

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PrepareLogin_vue__ = __webpack_require__(289);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_33ddfe53_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PrepareLogin_vue__ = __webpack_require__(496);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(494)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33ddfe53"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PrepareLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_33ddfe53_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PrepareLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-oms-auth/PrepareLogin.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-33ddfe53", Component.options)
  } else {
    hotAPI.reload("data-v-33ddfe53", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(495);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("602a2b7c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-33ddfe53\",\"scoped\":true,\"hasInlineConfig\":false}!../vue-loader/lib/selector.js?type=styles&index=0!./PrepareLogin.vue", function() {
     var newContent = require("!!../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-33ddfe53\",\"scoped\":true,\"hasInlineConfig\":false}!../vue-loader/lib/selector.js?type=styles&index=0!./PrepareLogin.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "\n.suki-logo[data-v-33ddfe53] {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n.prepare-login-container[data-v-33ddfe53] {\n  background: white;\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  top: 0px;\n  bottom: 0px;\n}\n", ""]);

// exports


/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.PdogLoad,
          expression: "PdogLoad"
        }
      ],
      staticClass: "prepare-login-container"
    },
    [
      _c("img", {
        staticClass: "suki-logo",
        attrs: { src: "https://oms.akitahub.com/img/dog_loading.gif" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33ddfe53", esExports)
  }
}

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

module.exports = {
  '56940': {
    name: 'A',
    id: '5e3548c6d32cb12606a34fba'
  },
  '56983': {
    name: 'Chou',
    id: '5ee750bfaf5cfe001a6f40da'
  },
  '56981': {
    name: 'Mustard sneakers',
    id: '5ee75026af5cfe001a6f40cf'
  },
  '56982': {
    name: 'Tallulah',
    id: '5ee74ff0af5cfe001a6f40c0'
  },
  '56984': {
    name: 'A pale petal',
    id: '5ef2db51b74c35001afef205'
  }
};

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getStoreBearer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBranchID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUnitID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getUserCashier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPOSID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getWerehouse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBranchName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSellsukiUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentBranchPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getStoreId; });

var getStoreBearer = function getStoreBearer() {
  var auth = window.localStorage.getItem('sellsuki.store.bearer');
  return auth;
};

var getSellsukiUser = function getSellsukiUser() {
  var user = window.localStorage.getItem('sellsuki.user');
  user = JSON.parse(user);
  return user;
};

var getUser = function getUser() {
  var user = window.localStorage.getItem('sellsuki.user');
  user = JSON.parse(user);
  var result = {
    id: user.user.id ? user.user.id : '',
    first_name: user.user.first_name ? user.user.first_name : '',
    last_name: user.user.last_name ? user.user.last_name : ''
  };
  return result;
};
function getUserCashier() {
  var user = window.localStorage.getItem('sellsuki.user');
  user = JSON.parse(user);
  var result = {
    id: user.user.id ? parseInt(user.user.id) : 0,
    name: user.user.first_name ? user.user.first_name + ' ' + user.user.last_name : '',
    email: user.user.email ? user.user.email : ''
  };
  return result;
}

var getBranchID = function getBranchID() {
  var results = window.localStorage.getItem('currentBranchPOS');
  return JSON.parse(results).branch_id;
};
var getUnitID = function getUnitID() {
  var results = window.localStorage.getItem('currentBranchPOS');
  return JSON.parse(results).unit_id;
};
var getPOSID = function getPOSID() {
  var results = window.localStorage.getItem('currentBranchPOS');
  return JSON.parse(results).pos_id;
};
var getWerehouse = function getWerehouse() {
  var results = window.localStorage.getItem('currentBranchPOS');
  return JSON.parse(results) ? JSON.parse(results).warehouse : '';
};
var getBranchName = function getBranchName() {
  var results = window.localStorage.getItem('currentBranchPOS');
  return results ? JSON.parse(results).name : '';
};
var getCurrentBranchPOS = function getCurrentBranchPOS() {
  var getItem = window.localStorage.getItem('currentBranchPOS');
  var result = getItem ? JSON.parse(getItem) : '';
  return result;
};

var getStoreId = function getStoreId() {
  var getItem = window.localStorage.getItem('currentBranchPOS');
  var result = getItem ? JSON.parse(getItem).store_id : '000000000';
  return result;
};


/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_selectStore__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helper_localStorage__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentEnv: "development",
      activeModal: false,
      isUpToDate: true,
      storeColors: {
        '56940': {
          name: 'A',
          color: '#1b0000'
        },
        '56983': {
          name: 'Chou',
          color: '#703b02'
        },
        '56981': {
          name: 'Mustard sneakers',
          color: '#5c3700'
        },
        '56982': {
          name: 'Tallulah',
          color: '#8b5057'
        },
        '56984': {
          name: 'A pale petal',
          color: '#004D40'
        }
      }
    };
  },

  components: {
    selectStore: __WEBPACK_IMPORTED_MODULE_5__views_selectStore__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['setSellsukiAuth', 'initState', 'setIsloading', 'init', 'setMainColor']), {
    checkVersion: function checkVersion() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/static/version.txt?t=' + Date.now()).then(function (response) {
        var clientScriptVersion = window.sellsukiVersion.trim();
        var serverScriptVersion = response.data.trim();
        if (clientScriptVersion === serverScriptVersion) {
          vm.isUpToDate = true;
        } else {
          vm.isUpToDate = false;
          vm.$dialog.confirm({
            title: 'CHECK VERSION UPDATE',
            message: 'Your version is behide, Please reload to latest version.',
            onConfirm: function onConfirm() {
              vm.setSellsukiAuth('');
              window.localStorage.removeItem('currentBranchPOS');
              window.location.href = "http://staging-oms-login.akitahub.com/#/logout?target=a-pos";
            }
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    sellsukiAuth: 'getSellsukiAuth',
    isLoading: 'getIsLoading',
    initailData: 'initailData',
    storeId: 'storeId'
  })),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var mainColor, currentBranchPOS;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setIsloading(true);
              _context.next = 3;
              return _this.initState();

            case 3:
              _context.prev = 3;
              _context.next = 6;
              return _this.init();

            case 6:
              _context.next = 15;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](3);

              console.log(_context.t0);
              _this.setSellsukiAuth('');
              _this.firebaseLogout();
              window.localStorage.removeItem('currentBranchPOS');
              window.location.href = "http://staging-oms-login.akitahub.com/#/logout?target=a-pos";

            case 15:
              mainColor = _this.storeColors[_this.storeId] ? _this.storeColors[_this.storeId] : {
                name: 'A',
                color: '#1b0000'
              };

              _this.setMainColor(mainColor.color);

              if (_this.sellsukiAuth) {
                _context.next = 20;
                break;
              }

              _context.next = 20;
              return _this.setSellsukiAuth(_this.$sellsuki_auth.getSellsukiData());

            case 20:
              currentBranchPOS = Object(__WEBPACK_IMPORTED_MODULE_6__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])();

              console.log(_this.sellsukiAuth.storeId);
              if (!currentBranchPOS || !currentBranchPOS.store_id) {
                _this.activeModal = true;
              }
              _this.setIsloading(false);

            case 24:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 8]]);
    }))();
  },
  created: function created() {
    this.checkVersion();
    setInterval(this.checkVersion, 60000);
  }
});

/***/ })

},[290]);


// WEBPACK FOOTER //
// static/js/app.fc1cdb292db48d10d10f.js